const Strings = Object.freeze({
  // ---------------------------- Traffic Errors ----------------------------
  INPUT_ERRORS: "errores de entrada: ",
  OUTPUT_ERRORS: "errores de salida: ",

  CABLE_DELAY: "Cable delay",
  LINE_DELAY: "Line delay",
  DELAY_POPUP_1: "Indica dos retrasos de propagación diferentes (uno u otro, dependiendo de la respuesta del dispositivo).",
  DELAY_POPUP_2: "Variaciones en estos valores indican problemas físicos en la infraestructura (cables y conectores) y, en el caso de “Line delay”, puede indicar un problema en las interfaces de red (transmisores y receptores).",
  DELAY_POPUP_3: "El valor indicativo máximo para el “Cable delay” es de 548 ns.",
  DELAY_POPUP_4: "Los diferentes retrasos indicados son:",
  DELAY_POPUP_5: "Retraso de propagación solo en la parte cableada;",
  DELAY_POPUP_6: "Incluye retrasos en cable, transmisor y receptor Ethernet.",

  IN_ERRORS_POPUP: "Indica la suma de todos los paquetes recibidos con algún tipo de error. Cuando hay errores de este tipo, se sugiere:",
  OUT_ERRORS_POPUP: "Indica la suma de todos los paquetes con algún tipo de error que impidió la correcta transmisión. Cuando hay errores de este tipo, se sugiere:",
  SOLVE_ERRORS_POPUP: "Las sugerencias de corrección se indican en la lista de acciones. Para obtener acceso, simplemente haga clic en el botón \"Exportar lista de acciones\" en la pantalla TS Expert.",

  TURN_ON: "encender",
  TURN_OFF: "apagar",
  TURNED_ON_1: "encendido",
  MEASUREMENT_INTERVAL: "Período de medición",

  DUPLEX_MODE_POPUP: "Indica el modo Duplex de la interfaz (Full o Half Duplex) y la tasa de comunicación.",

  IN_PACKETS: "Paquetes de entrada",
  OUT_PACKETS: "Paquetes de salida",

  ARE_YOU_SURE_YOU_WANT: "Estás seguro que deseas",
  THE_PORTS_FILTER: " el filtro de puertas?",

  // ---------------------------- Configuration page related ----------------------------
  LOGIN_CREDENTIALS_FAILURE: "Ocurrió un error al iniciar sesión: Nombre de usuario o contraseña incorrectos.",
  LOGIN_GENERAL_FALIURE: "Ocurrió un error al iniciar sesión:",
  GPG_ALERT_MESSAGE: "Solo es posible enviar archivos con extensión .gpg",
  XML_ALERT_MESSAGE: "Solo es posible enviar archivos con extensión .xml",
  SEND_FILE_SUCCESS: "El archivo fue enviado con éxito.",
  SEND_FILES_SUCCESS: "Los archivos han sido enviados con éxito.",
  SEND_FILE_SUCCESS_WARNING: "No olvide verificar que la tarjeta de red de su computadora esté en la misma subred que del IP: ",
  SEND_FILE_FAILURE: "Ocurrió un error al cargar el archivo.",
  SEND_FILES_FAILURE: "Ocurrió un error al cargar los archivos.",
  SEND_FILE_WAITING: "Enviando el archivo.",
  SEND_FILES_WAITING: "Enviando los archivos.",
  SEND_FILE_WRONG_FILENAME: "Nombre inválido. El archivo de actualización debe llamarse: updatePN.tar.gz.gpg",
  SEND_FILE_CORRUPTED_FILE: "El archivo de actualización se dañó durante el envío.",
  THE_FOLLOWING_FILES_COULD_NOT_BE_SENT: "Ocurrió un error al enviar los siguientes archivos GSDML: ",
  THE_FOLLOWING_FILES_COULD_NOT_BE_REMOVED: "Ocurrió un error al remover los siguientes archivos GSDML: ",
  SEND_CONFIG_SUCCESS: "Las configuraciones han sido enviadas con éxito",
  SEND_CONFIG_FAILURE: "Ocurrió un error al enviar las configuraciones.",
  SEND_NTP_CONFIG_WAITING: "Enviando las configuraciones del servidor NTP.",
  SEND_NTP_CONFIG_DONE: "Se han enviado las configuraciones del servidor NTP.",

  SEND_CONFIG_WAITING: "Enviando las configuraciones.",
  SEND_CONFIG_WAITING_2: "Terminando de enviar las configuraciones.",
  SEND_CONFIG_DONE: "Configuraciones enviadas.",
  SEND_WLAN_CONFIG_WAITING: "Enviando las configuraciones, por favor aguarde. Esto puede llevar cerca de um minuto.",
  UPDATE_WLAN_CONFIG_ERROR: "No se puede conectar a la red WLAN. Si el problema persiste, intente reiniciar el monitor o el router.",
  UPDATE_OFFICE_INTERFACE_CONFIG_ERROR: "Ocurrió un error al configurar la interfaz office. Si el problema persiste, intente reiniciar el monitor o el enrutador.",

  LOADING_WAITING: "Cargando informaciones, por favor aguarde.",

  START_MESSAGE_SUCCESS: "El monitor se iniciará en 15 segundos.",
  START_MESSAGE_FAILURE: "Ocurrió un error al iniciar el monitor.",
  STOP_MESSAGE_SUCCESS: "El monitor se detendrá en 15 segundos.",
  STOP_MESSAGE_FAILURE: "Ocurrió un error al detener el monitor.",
  WAITING: "Aguarde un instante",
  CLEAN_LOG_SUCCESS: "El log ha sido limpiado con éxito.",
  CLEAN_LOG_FAILURE: "Ocurrió un error al borarar el log.",
  RESET_TRAFFIC_SUCCESS: "Los valores se restablecerán a cero en el próximo escaneo.",
  RESET_TRAFFIC_FAILURE: "Ocurrió un error al borrar los incrementos de error.",
  RESET_DEVICES_SUCCESS: "Los datos del dispositivo se han borrado correctamente.",
  RESET_DEVICES_FAILURE: "Ocurrió un error al borrar los dadtos de los dispositivos.",
  CHANGE_USERNAME_SUCCESS: "El nombre de usuario se ha cambiado con éxito. Inicie sesión de nuevo.",
  CHANGE_USERNAME_FAILURE: "Ocurrió un error al cambiar el nombre de usuario:",
  USERNAME_TOO_SHORT: "El nombre de usuario debe contener al menos un carácter.",
  PASSWORD_MISSMATCH: "Las contraseñas ingresadas no coinciden",
  CHANGE_PASSWORD_SUCCESS: "La contraseña ha sido cambiada con éxito. Inicie sesión de nuevo.",
  CHANGE_PASSWORD_FAILURE: "Hubo un error al cambiar la contraseña: ",

  VERIFY_THE_FOLLOWING_INFO: "Por favor verifique la siguiente información:",
  INVALID_IP: "\n- La IP ingresada no es válida",
  INVALID_SUBMASK: "\n- La mascarilla ingresada no es válida",
  INVALID_GATEWAY: "\n- El gateway ingresado no es válido",
  INVALID_DNS: "\n- El DNS ingresado no es válido",
  LOOPBACK_IP: "\n- La IP de loopback (127.0.0.1) no se puede utilizar como IP del monitor",
  LOOPBACK_IP_NTP: "\n- La IP de loopback (127.0.0.1) no se puede utilizar como IP del servidor NTP",
  TAG_TOO_LONG: "\n- El tamaño de la tag  no puede exceder los 30 caracteres",
  EMPTY_WIFI_PWD: "\n- La contraseña wifi no puede estar vacía",
  SELECT_TIMEZONE: "\n- Es necesario seleccionar un Timezone para configurar el servidor NTP",
  SAME_SUBNET_IP_1: "\n- La dirección IP de la interfaz office no puede estar en la misma subred que la interfaz PROFINET.",
  SAME_SUBNET_IP_2: "\n- La dirección IP de la interfaz PROFINET no puede estar en la misma subred que la interfaz office.",
  SUBNET_OVERLAP_OFFICE: "\n- El TS Monitor PROFINET ha detectado que existe una superposición de direcciones entre la subred de la interfaz PROFINET y la subred de la interfaz office. Por este motivo no es posible configurar la interfaz office con la dirección IP y máscara elegidas.",
  SUBNET_OVERLAP_PROFINET: "\n- El TS Monitor PROFINET ha detectado que existe una superposición de direcciones entre la subred de la interfaz PROFINET y la subred de la interfaz office. Por este motivo, no es posible configurar la interfaz PROFINET con la dirección IP y la máscara elegidas.",
  SUBNET_OVERLAP_WLAN: "\n- El TS Monitor PROFINET ha detectado que existe una superposición de direcciones entre la subred de la interfaz PROFINET y la subred de la WLAN. Por este motivo, no es posible configurar la WLAN con la dirección IP y la máscara elegidas.",
  SUBNET_OVERLAP_PROFINET_WLAN: "\n- El TS Monitor PROFINET ha detectado que existe una superposición de direcciones entre la subred de la interfaz PROFINET y la subred de la WLAN. Por este motivo, no es posible configurar la interfaz PROFINET con la dirección IP y la máscara elegidas.",
  ZERO_IP_MSG: "\n- La dirección IP 0.0.0.0 no se puede utilizar como IP del monitor.",
  ZERO_IP_MASK_MSG: "\n- La IP 0.0.0.0 no se puede utilizar como mascarilla de red",
  BROADCAST_IP_MSG: "\n- La IP de broadcast no se puede utilizar como IP del monitor.",
  NETWORK_IP_MSG: "\n- La IP de la red no se puede utilizar como IP del monitor.",
  BROADCAST_GATEWAY_MSG: "\n- La IP de broadcast no se puede utilizar como IP de gateway.",
  NETWORK_GATEWAY_MSG: "\n- La IP de la red no se puede utilizar como IP de gateway.",

  MONITORING_ON: "Encendido",
  MONITORING_OFF: "Apagado",

  GENERATING_REPORT_WAITING: "Generando informe, por favor espere",

  ALTER_USERNAME: "CAMBIAR USUÁRIO",
  ALTER_PASSWORD: "CAMBIAR CONTRASEÑA",

  SELECT_FILE: "Por favor seleciona un archivo para enviar",
  SELECT_AT_LEAST_ONE_FILE: "Por favor seleciona al menos un archivo para enviar",
  SELECT_AT_LEAST_ONE_FILE_TO_DELETE: "Por favor selecione al menos un archivo para remover",

  DO_NOT_CLOSE_THIS_TAB: "Deje esta pestaña abierta para seguir la actualización.",
  UPDATING_MONITOR_FILES: "Actualizando archivos en el monitor. Espere por favor.",
  MONITOR_FILES_UPDATED_SUCCESSFULLY: "Archivos actualizados, preparando para reiniciar el monitor.",
  RESTARTING_MONITOR_WAIT: "Reiniciando el monitor, aguarde algunos minutos.",
  UPDATE_SUCCESS: "A actualización ha sido realizada com éxito!",
  UPDATE_ERROR_STRING: "Ocurrió el seguinte error al actualizar el monitor: ",

  SWEEP_POPUP_MSG: " Permite la configuración de búsqueda personalizada para hasta 5 subredes.",
  MONITORING_QUESTION_ICON_INFO: "Activa y desactiva el envío y captura de mensajes de forma activa. Cuando está apagado, el monitor no activa mensajes y no adquiere datos.",
  DEVICE_SEARCH_QUESTION_ICON_INFO: "Seleccione búsqueda continua (constante) o única para disminuir el envío de mensajes. En el modo de búsqueda única, no se encontrarán los nuevos dispositivos que aparecen en la red.",
  GSDML_QUESTION_ICON_INFO: "Cargar los archivos GSDml en TS Monitor amplía considerablemente la capacidad de diagnóstico de los activos, permitiendo la interpretación de información específica del fabricante que solo se puede mostrar si el monitor tiene estos archivos cargados.",

  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS: "Modifique al menos uno de los campos para actualizar la configuración de la interfaz.",
  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS_WLAN: "Modifique al menos uno de los campos para actualizar la configuración de WLAN.",

  TAG_WAS_CHANGED_SUCCESSFULLY: "La tag del monitor ha sido modificada con éxito.",
  TAG_CHANGE_FAILURE: "Ocurrió un error al modificar la tag del monitor.",

  REMEMBER_TO_UPDATE_BROWSER_ADDRESS_TO: "\nRecuerda actualizar la dirección en el navegador a: ",
  UPDATE_INTERFACE_CONFIG_SUCCESS: "¡La configuración de la interfaz ha sido actualizada con éxito!",
  UPDATE_WLAN_CONFIG_SUCCESS: "¡La configuración de WLAN ha sido actualizada con éxito!",
  UPDATE_OFFICE_INTERFACE_CONFIG_SUCCESS: "¡La configuración de la interfaz de Office se ha actualizado con éxito!",

  CONTINUOUS: "Contínua",
  UNIQUE: "Única",

  ALTER_MONITOR_CONFIG: "¿Está seguro de que desea cambiar la configuración del monitor?",
  RESTART_SYSTEM: " Reiniciar Sistema",
  CONFIRM_RESTART_SYSTEM: "¿Está seguro de que desea reiniciar el sistema?",
  RESTART_SYSTEM_FAILURE: "Ocurrió un error al intentar reiniciar o sistema.",
  RESTART_SYSTEM_SUCCESS: "Solicitud de reinicio enviada con éxito. Espere aproximadamente 3 minutos para que el sistema se reinicie por completo.",

  WI_FI: "Wi-fi",
  MANAGE: "Gestionar",

  TAG_CONFIG: "Tag de la red",

  ETHERNET: "Ethernet",
  WLAN: "WLAN",

  NTP_SERVER: "Servidor NTP",

  TURN_NTP_SERVER_ON: "Encender servidor NTP",
  TURN_NTP_SERVER_ON_QUESTION: "¿Está seguro de que desea activar el servidor NTP? Para ello será necesario reiniciar el monitor.",

  NTP_INFO_TURNED_ON_SUCCESS: "El servidor NTP se ha conectado con éxito.",
  NTP_INFO_TURNED_ON_FAILURE: "Ocurrió un error al conectar el servidor NTP.",
  TURN_ON_DATE: "\nLa hora del servidor se ha actualizado a: ",

  MONITOR_WILL_BE_RESTARTED: "\nEl monitor ahora se reiniciará,",
  MONITOR_RESTART_SUCCESS: "El monitor se ha reiniciado correctamente.",
  MONITOR_RESTART_FAILURE: "Ocurrió un error al reiniciar el monitor.",

  NTP_INFO_TURNED_OFF_SUCCESS: "El servidor NTP ha sido apagado con éxito.",
  NTP_INFO_TURNED_OFF_FAILURE: "Ocurrió un error al apagar el servidor NTP.",
  TURN_OFF_DATE: "\nTiempo de apagado: ",
  NTP_INFO_FAILURE: "No se pudo sincronizar con el servidor. Si el error persiste, póngase en contacto con el administrador del servidor NTP.",

  PROCESSING_NTP_INIT: "Comenzando el procesamiento de las informaciones del servidor NTP.",
  PROCESSING_NTP_INFO: "Procesando las informaciones del servidor NTP.",
  PROCESSED_NTP_INFO: "Las informaciones del servidor NTP fureon procesadas.",
  PROCESSING_NTP_ERROR: "Ocurrió un error al enviar las informaciones al servidor NTP. Compruebe que la dirección IP del servidor sea correcta. Si es así, compruebe también si el servicio NTP está activado y vuelva a intentarlo.",

  ETHERNET_CONFIG_POPUP: "Campo de configuración de la interfaz Ethernet conectada a la red industrial y utilizada por TS Monitor para la captura de datos.",
  WLAN_CONFIG_POPUP: "Campo de configuración de la interfaz inalámbrica, cuando el adaptador está disponible, se utiliza para la supervisión y el acceso web a los datos de TS Monitor. Esta red está aislada de la red Ethernet/Industrial.",
  OFFICE_CONFIG_POPUP: "Campo de configuración de la interfaz Ethernet utilizada para supervisión y acceso web a los datos del TS Monitor. Esta red está aislada de la red Ethernet/industrial.",
  BLACKLIST_CONFIG_POPUP: "Permite la exclusión de algunos servicios de recopilación de datos de TS Monitor.",
  TS_EXPERT_CONFIG_POPUP: "Permite habilitar/deshabilitar las no conformidades a ser reportadas por la herramienta.",

  ALTER: "Cambiar",
  USER: "Usuário",
  NEW_PWD: "Nueva contraseña",
  REPEAT_PWD: "Repetir contraseña",
  REASON_DP: "Razón: ",
  TEST_NETWORK: "Red de teste",
  EDIT: "Editar",
  SWEEP: "Búsqueda",
  DEVICE_SEARCH: "Búsqueda por Dispositivos",
  SOFTWARE_UPDATE: "Actualización de Software",
  CURRENT_VERSION: "Versión actual: ",
  UPDATE: "Actualizar",
  GSDML_FILES: "Archivos GSDML",
  SEND: "Enviar",
  CLEAR: "Limpiar",
  TRAFFIC_ERROR_INCREMENT: "Incremento de errores de Tráfico",
  REPORT: "Informe",
  ALTER_LOGIN: "Cambiar login",
  INTERFACE_CONFIG: "Configuraciones de la interfaz",
  INTERFACE_PROFINET_CONFIG: "Configuración de la interfaz PROFINET",
  ENTER: "Entrar",

  SNMP_MODE: "Modo SNMP",
  SNMP_MODE_QUESTION_ICON_INFO_1: "Al colocar el TS Monitor PROFINET en la red, si se detecta que algunos dispositivos no están funcionando correctamente, es posible activar el modo lento SNMP.",
  SNMP_MODE_QUESTION_ICON_INFO_2: "Habilitar este modo reducirá considerablemente la velocidad a la que se envían las consultas SNMP, lo que puede resolver el problema.",
  SNMP_MODE_FAST: "Rápido",
  SNMP_MODE_SLOW: "Lento",
  SNMP_MODE_WAS_CHANGED_SUCCESSFULLY: "El modo SNMP se cambió con éxito.",
  SNMP_MODE_CHANGE_FAILURE: "Ocurrió un error al cambiar el modo SNMP.",

  PROFINET_INTERFACE: "Interfaz PROFINET",
  OFFICE_INTERFACE: "Interfaz OFFICE",

  // ---------------------------- Sweep Page ----------------------------
  PERSONALIZED_SWEEP: "Búsqueda personalizada",

  SWEEP_ON: "Encendida",
  SWEEP_OFF: "Apagada",
  BANDS: "Rangos",

  FIRST_BAND: "1º rango",
  SECOND_BAND: "2º rango",
  THIRD_BAND: "3º rango",
  FOURTH_BAND: "4º rango",
  FIFTH_BAND: "5º rango",

  BEGINNING: "Início",
  END: "Fin",

  ALERT_MESSAGE_PLACEHOLDER: "Los campos de los siguientes rangos tienen problemas: ",

  FIRST_SUBNETWORK_ADDRESS_NOT_VALID: "\n - La dirección del  1º rango no es válida",
  FIRST_SUBNETWORK_START_LESS_THAN_FINISH: "\n - La dirección de inicio del  1º rango es mayor o igual que la del final",
  FIRST_SUBNETWORK_HAS_UNFILLED_FIELDS: "\n - El 1º rango tiene campos sin llenar",

  SECOND_SUBNETWORK_ADDRESS_NOT_VALID: "\n - La dirección del  2º rango no es válida",
  SECOND_SUBNETWORK_START_LESS_THAN_FINISH: "\n - La dirección de inicio del  2º rango es mayor o igual que la del final",
  SECOND_SUBNETWORK_HAS_UNFILLED_FIELDS: "\n - El 2º rango tiene campos sin llenar",

  THIRD_SUBNETWORK_ADDRESS_NOT_VALID: "\n - La dirección del  3º rango no es válida",
  THIRD_SUBNETWORK_START_LESS_THAN_FINISH: "\n - La dirección de inicio del  3º rango es mayor o igual que la del final",
  THIRD_SUBNETWORK_HAS_UNFILLED_FIELDS: "\n - El 3º rango tiene campos sin llenar",

  FOURTH_SUBNETWORK_ADDRESS_NOT_VALID: "\n - La dirección del  4º rango no es válida",
  FOURTH_SUBNETWORK_START_LESS_THAN_FINISH: "\n - La dirección de inicio del  4º rango es mayor o igual que la del final",
  FOURTH_SUBNETWORK_HAS_UNFILLED_FIELDS: "\n - El 4º rango tiene campos sin llenar",

  FIFTH_SUBNETWORK_ADDRESS_NOT_VALID: "\n - La dirección del  5º rango no es válida",
  FIFTH_SUBNETWORK_START_LESS_THAN_FINISH: "\n - La dirección de inicio del  5º rango es mayor o igual que la del final",
  FIFTH_SUBNETWORK_HAS_UNFILLED_FIELDS: "\n - El 5º rango tiene campos sin llenar",

  SWEEP_DATA_SENT_SUCCESSFULLY: "La configuración de búsqueda se guardó con éxito.",
  SWEEP_DATA_SENT_ERROR: "Ocurrió un error al guardar la configuración de búsqueda.",
  SPECIFY_AT_LEAST_ONE_SUBNETWORK: "Debe especificar al menos una subred para guardar la búsqueda personalizada.",

  UNABLE_TO_SAVE_CUSTOM_SWEEP: "No se puede guardar la búsqueda personalizada porque:",
  _THE: "- A ",
  BAND_HAS_IPS_NOT_IN_SUBNETWORK: "º rango tiene IPs que no están en la subred del monitor",
  SENDING_DATA: "Enviando datos",

  // ---------------------------- PDF Report ----------------------------
  REPORT_EXPORT_NAME_PDF: "Informe TS Monitor PROFINET.pdf",
  FINISHING: "Finalizando...",
  SAVE_REPORT: "Guardar informe",

  PROJECT_NAME_1: "Nombre del proyecto",
  LOCATION_1: "Localización",
  COMPANY_NAME_1: "Nombre de la empresa",
  RESPONSIBLE_NAME: "Nombre del responsable",
  ADDRESS: "Ubicación",
  CITY: "Ciudad",
  TEL: "Teléfono",
  CLIENT_LOGO: "Logo del cliente",
  EMAIL: "E-mail",
  EXECUTING_COMPANY_LOGO: "Logo de la empresa ejecutora",

  GENERAL_INFO_TITLE: "1. Visión Genetal",
  LIVE_LIST_TITLE: "2. Live List",
  TOPOLOGY_TITLE: "3. Topología",
  TRAFFIC_INPUT_TITLE: "4. Errores en el tráfico de entrada",
  TRAFFIC_OUTPUT_TITLE: "5. Errores en el tráfico de salida",
  LOG_PAGE_TITLE: "6. Log de eventos",

  ACTIVE_TYPE: "ACTIVOS",
  NOT_ACTIVE_TYPE: "DESAPARECIDOS",

  CONFORM_STRING: "Conforme",
  CONFORM_W_RESTRICTION_STRING: "Conforme con restriciones",
  NON_CONFORM_STRING: "No conforme",

  GENERATING_REPORT_SUCCESS: "Informe generado con éxito. Para guardarlo, haga clic en Guardar informe abajo.",

  CONFORMITY: "Conformidad",
  DROPDOWN_PLACEHOLDER: "Elija una opción",
  GENERATE_REPORT: "Generar informe",
  CLIENT_INFO: "Informaciones del cliente",
  EXECUTING_COMPANY_INFO: "Informaciones de la empresa ejecutora",
  ANNOTATIONS: "Anotaciones",
  CONCLUSION: "Conclusión",

  HEADER_TEXT: "Informe de datos - TS Monitor PROFINET",
  REPORT_EXPORT_NAME: "Informe TS Monitor PROFINET",

  GENERAL_REPORT: "Informe general – TS Monitor PROFINET",
  DATA_REPORT: "Informe de datos – TS Monitor PROFINET",

  PROJECT_NAME: "- Nombre del proyecto:",
  NETWORK_NAME: "- Nombre de la red:",
  LOCATION: "- Localización:",
  COMPANY_NAME: "- Nombre de la empresa:",
  ACCOUNTABLE_NAME: "- Nombre del responsable:",
  COMPANY_ADDRESS: "- Dirección:",
  COMPANY_CITY: "- Ciudad:",
  COMPANY_TEL: "- Teléfono:",

  EXECUTING_COMPANY_NAME: "- Nombre de la empresa:",
  EXECUTING_ACCOUNTABLE_NAME: "- Nombre del responsable:",
  EXECUTING_TEL: "- Teléfono:",
  EXECUTING_EMAIL: "- E-mail:",

  MONITORING_INFO: "Informaciones del monitoreo",
  ETHERNET_INFO: "Informaciones ETHERNET",
  WLAN_INFO: "Informaciones WLAN",
  ETHERNET_OFFICE_INFO: "Informaciones ETHERNET Office",

  NETWORK_TAG_DP: "- Tag de la red: ",
  NETWORK_NAME_DP: "- Nombre de la red: ",
  MONITOR_IP_DP: "- IP del monitor: ",
  MONITOR_SUBMASK_DP: "- Mascarilla del monitor: ",
  MONITOR_VERSION_DP: "- Versión del monitor: ",
  MONITOR_TIME_ON_DP: "- Tiempo encendido: ",
  MEASUREMENT_INTERVAL_DP: "- Periodo de medición: ",
  REPORT_GENERATION: "- Generación de informe: ",

  IP_DP: "- IP: ",
  MASK_DP: "- Mascarilla: ",
  GATEWAY_DP: "- Gateway: ",
  DNS_DP: "- DNS: ",
  MODO_DP: "- Modo de configuración: ",

  SUMMARY: "Índice",
  OVERVIEW: "Visión General",
  LIVE_LIST: "Live List",
  INVENTORY: "Inventario",
  TOPOLOGY: "Topología",
  GRAPHIC_TOPOLOGY: "Topología gráfica",
  IN_TRAFFIC_ERRORS: "Errores en el tráfico de entrada",
  OUT_TRAFFIC_ERRORS: "Errores en el tráfico de salida",
  LOG: "Log",
  CONFIG: "Configuraciones",
  DISCLAIMER: "Aviso legal",

  M_MONITORING_OVERVIEW_PAGE_TITLE: "1. - Visión General",
  M_MONITORING_LIVE_LIST_PAGE_TITLE: "2. - Live List",
  M_MONITORING_INVENTORY_PAGE_TITLE: "3. - Inventario",
  M_MONITORING_TOPOLOGY_PAGE_TITLE: "4. - Topología",
  M_MONITORING_IN_TRAFFIC_ERRORS_PAGE_TITLE: "5. - Errores en el tráfico de entrada",
  M_MONITORING_OUT_TRAFFIC_ERRORS_PAGE_TITLE: "6. - Errores en el tráfico de salida",
  M_MONITORING_LOG_PAGE_TITLE: "7. - Log de eventos",

  TS_MONITOR_VER_DP: "TS Monitor PROFINET - Versión ",
  NETWORK_STATUS_DP: "Estado de la red: ",
  DEVICE_DATA: "Datos de los dispositivos",

  CONTROLLERS_DP: "IO Controllers: ",
  DEVICES_DP: "IO Devices: ",
  SUPERVISORS_DP: "Supervisores: ",
  SUPERVISORS: "Supervisores",
  OTHER_DEVICES_DP: "No PROFINET: ",
  OTHER_DEVICES: "No PROFINET",
  FAULTS_DP: "Fallas: ",
  ALARMS_DP: "Alarmas: ",
  IN_TRAFFIC_DP: "Tráfico ethernet de entrada: ",
  OUT_TRAFFIC_DP: "Tráfico ethernet de salida: ",
  NETWORK_AVAILABILITY_DP: "Disponibilidad de la red: ",

  NAME: "Nombre",
  MODEL: "Modelo",
  MAC: "MAC",
  MACS: "MACs",
  IP: "IP",
  IPS: "IPs",
  FUNCTION: "Función",
  STATUS: "Status",
  ON_TIME: "Tiempo encendido",
  EVENT_TYPE: "Tipo de evento",

  MONITORING_BLACKLIST_STRING: "Blacklist de monitoreo",
  MONITORING_BLACKLIST_STRING_1: "Blacklist de",
  MONITORING_BLACKLIST_STRING_2: "monitoreo",
  OFFLINE_STRING: "Offline",
  ONLINE_STRING: "Online",
  FAULT_STRING: "Falla",
  DUPLICATE_IP_STRING: "IP duplicado",
  CONFIG_ERROR_STRING: "Error de configuración",

  BLACKLIST_OK_STRING: "Blacklist - OK",
  BLACKLIST_ALARM_STRING: "Blacklist - Alarma",
  BLACKLIST_OFFLINE_STRING: "Blacklist - Offline",
  BLACKLIST_ONLINE_STRING: "Blacklist - Online",
  BLACKLIST_FAULT_STRING: "Blacklist - Falla",
  BLACKLIST_DUPLICATE_IP_STRING: "Blacklist - IP duplicado",
  BLACKLIST_CONFIG_ERROR_STRING: "Blacklist - Error de configuración",

  SNMP: "SNMP",
  PORT: "Puerta",
  NEIGHBOUR_NAME: "Nombre vecino",
  NEIGHBOUR_PORT_1: "Puerta",
  NEIGHBOUR_PORT_2: "vecino",
  NEIGHBOUR_IP: "IP vecino",

  LAST_200_EVENTS: "200 últimos eventos",
  DESCRIPTION: "Descripción",
  HORARY: "Horario",

  END_OF_REPORT: "Fin del informe",
  DISCLAIMER_TEXT: "Los datos y valores mostrados en este informe son meramente auxiliares para el especialista en PROFINET, de tal forma que cualquier indicación de corrección debe ser hecha por el usuario. Por esta razón, se recomienda que haya acompañamiento un ingeniero certificado en PROFINET o técnico responsable por el análisis para certificar las informaciones prestadas por el producto. Por lo tanto Toledo & Souza se exime de qualquier responsabilidad, pérdidas o daños, directos o indirectos causados por las interpretaciones del software, no ofreciendo ninguna garantia en relación a la integridad, calidad o adecuación de la información proporcionada, pues dependen del análisis técnico de un profesional capacitado, y en su defecto, el usuario asumirá el riesgo de que el contenido sea inexacto, incompleto o no se ajuste a sus necesidades y requerimientos.",

  NO_INPUT_TRAFFIC_ERRORS: "La red no tiene errores en el tráfico de entrada",
  NO_OUTPUT_TRAFFIC_ERRORS: "La red no tiene errores en el tráfico de salida",

  DEVICE_HAS_JOINED_THE_NETWORK: "El dispositivo entró en la red",
  DETAILS: "Detalles:",

  PAGE: "Página",
  INPUT: "Entrada",
  OUTPUT: "Salida",
  ERRORS_IN: "Errores en la",
  PORT_STATUS: "Status de la puerta",
  REPORTING: " informando:",
  TIP: "Consejo:",
  THE_DEVICE: "El dispositivo",
  OF_IP: "de IP",
  JOINED_THE_NETWORK: "entró en la red.",
  THE_PORT: "La puerta",
  IS_CONNECTED_WITH_PORT: "está conectada a la puerta",
  FROM_DEVICE: "del dispositivo",

  // ---------------------------- Alarms ----------------------------
  ACTIVE_DP: "Activos:",
  NOT_ACTIVE_DP: "Desaparecidos:",
  ALARM: "Alarma",
  ALARMS: "Alarmas",

  // ---------------------------- OTHERS ----------------------------
  BEFORE_MONITOR_INIT_STR: "Anterior a la última inicialización",
  REMOVE_DEVICE_SUCCESS: "El dispositivo será eliminado en 30 segundos como máximo.",
  REMOVE_DEVICE_FAILURE: "Ocurrió un error al eliminar el dispositivo: ",

  OK_STRING: "OK",
  WITH_DIAGNOSTIC_STRING: "Con alarma",
  WITH_FAILURE_STRING: "Con falla",
  UNKNOWN: "Desconocido",
  NO_ANSWER: "Sin respuesta",
  NO_EVENT: "Ningún evento",
  LOG_WAITING: "Cargando datos del log",
  GO_TO_LOG_OR_REMOVE_POSITIONING: "Ir para log o excluir dispositivo",
  ASK_DELETE_OR_LOG: "Desea ir para la página de log o excluir el dispositivo de la lista?",
  DELETE: "Excluir",
  GO_TO_LOG: " Ir para log",
  LIVE_LIST_INPUT_TEXT_PLACEHOLDER: "Filtrar por IP, MAC, nombre, o status",
  TOPOLOGY_INPUT_TEXT_PLACEHOLDER: "Filtrar por IP, nombre o modelo",
  TRAFFIC_INPUT_TEXT_PLACEHOLDER: "Filtrar por IP o nombre",
  LOG_INPUT_TEXT_PLACEHOLDER: "Filtrar por nombre, modelo o IP",
  GRAPHIC_TOPOLOGY_INPUT_PLACEHOLDER: "Buscar por IP, Tag o profiname",
  PING_INPUT_TEXT_PLACEHOLDER: "Filtrar por IP o MAC",
  FAULTS: "Fallas",
  ACTUAL_MEDIUM: "Actual / Médio",
  AVAILABILITY: "Disponibilidad",
  STATISTICS: "Estatísticas",
  BILLIONS_OF: "Billón de",
  ONE_MILLION_OF: "Millón de",
  ONE_BILLION_OF: "Billón de",
  MILLIONS_OF: "Millón de",
  THOUSAND: "Mil",
  THOUSAND_NO_CAPITAL: " mil",
  MILLION_NO_CAPITAL: " millón",
  MILLIONS_NO_CAPITAL: " millones",
  BILLION_NO_CAPITAL: " billón",
  BILLIONS_NO_CAPITAL: " billones",
  LAST_EVENT: "Último evento: ",
  UP_TIME: "Tempo encendido:",
  MONITORING: "Monitoreo: ",
  TURNED_OFF: "Apagado ",
  TURNED_ON: "Encendido ",
  MONITORING_ON_TOOLTIP: "Servicio de monitoreo encendido.",
  MONITORING_OFF_TOOLTIP: "Serviço de monitoreo apagado. Para encender el servicio accese a la ventada MONITOREO dentro de la pestaña de Configuraciones.",
  MONITORING_GETTING_CONNECTION: "Estabelecendo conexión.",
  ZERO_IP: "0.0.0.0",

  ALARMS_QUESTION_INFO: "Indica el número de alarmas a las que respondieron los dispositivos. Las alarmas indican condiciones de estado anormales del dispositivo, como cortocircuito, problema de alimentación, falta de módulo, etc.",
  FAULTS_QUESTION_INFO: "Indica la cantidad de veces que un dispositivo PROFINET no respondió a los mensajes enviados por TS Monitor.",

  AVAILABILITY_QUESTION_INFO_1: "Indica el porcentaje de tiempo que el dispositivo fue detectado en la red, es decir, estuvo accesible a través de la red.",
  AVAILABILITY_QUESTION_INFO_2: "Este parámetro no tiene en cuenta ninguna otra condición, como si el dispositivo estaba funcionando o no, sino el hecho de que responde a TS Monitor.",

  SHOW_ONLY_ERROR_DEVICES: "Mostrar apenas dispositivos con errores",

  PORTS_FILTER_LABEL: "Filtro de puertas",
  PORTS_FILTER_POPUP_1: "Algunos dispositivos presentan pérdidas de paquetes en las puertas internos para los cuales no existe una acción correctiva posible por parte del usuario, y no traen información relevante para el análisis de la propia red.",
  PORTS_FILTER_POPUP_2: "El filtro elimina estas puertas, sin embargo, las puertas con nombres inusuales pueden eliminarse y, por esta razón, el filtro puede desactivarse para permitir una visualización completa.",

  PORTS_FILTER_TURN_ON_FAILURE: "Ocurrió un error al encender el filtro de puerta.",
  PORTS_FILTER_TURN_OFF_FAILURE: "Ocurrió un error al apagar el filtro de puerta.",

  DEVICE: "Dispositivo",

  LIVE_LIST_OK_POPUP_TEXT: "Dispositivo en operación normal, o sea, en troca de datos.",
  LIVE_LIST_DIAGNOSTIC_POPUP_TEXT: "Dispositivo en modo de funcionamiento normal ha señalado una condición de diagnóstico.",
  LIVE_LIST_FAULT_POPUP_TEXT: "El dispositivo que estaba en el modo de funcionamiento normal (OK) ya no se comunica en la red PROFINET y, por lo tanto, tiene fallas.",
  LIVE_LIST_ONLINE_POPUP_TEXT: "El dispositivo está físicamente en la red PROFINET y no intercambia datos con el controlador. Este comportamiento se debe a que el dispositivo no está activo ni configurado en el proyecto del IO Controller.",
  LIVE_LIST_OFFLINE_POPUP_TEXT: "Dispositivo Ethernet que se ha desconectado de la red.",
  LIVE_LIST_DUPLICATE_IP_POPUP_TEXT: "Cuando más de un dispositivo tiene la misma dirección IP.",
  LIVE_LIST_DUPLICATE_IP_POPUP_TEXT_2: "Al hacer clic en la celda puedes eliminar el dispositivo, si lo deseas.",
  LIVE_LIST_BLACKLIST_POPUP_TEXT: "El usuario puede poner un Dispositivo IO en modo Lista Negra, para no generar eventos repetitivos en el Log.",
  LIVE_LIST_CONFIG_ERROR_POPUP_TEXT: "Dispositivo con diferentes números de identificación entre un módulo configurado e instalado físicamente (información tomada del GSDml del dispositivo). La descripción se presenta en el registro con más detalle.",

  LIVE_LIST_CSV_HEADER: "Nombre,Tag,MAC,IP,Alarmas,Fallas,Ping actual (ms),Ping médio (ms),Pings perdidos,Pings perdidos (%),Disponibilidad,Status\n",
  LIVE_LIST_CSV_EXPORT_NAME: "Live List.xlsx",

  PS: "Nota:",

  IP_POPUP_2: "Si el dispositivo pierde su dirección IP, tendrá un fondo naranja, como en el siguiente ejemplo.",
  IP_POPUP_3: "Además, al hacer clic en la celda podrás eliminar el dispositivo, si lo deseas.",

  REMOVE_LOST_IP_MODAL_HEADER: "Eliminar dispositivo con pérdida de dirección IP",
  REMOVE_LOST_IP_MODAL_CONTENT_1: "¿Está seguro de que desea eliminar el dispositivo con dirección IP: 0.0.0.0?",
  REMOVE_LOST_IP_MODAL_CONTENT_2: "Si el dispositivo aún pierde su dirección IP, se agregará nuevamente a la Live List en el siguiente ciclo de búsqueda del TS Monitor PROFINET.",

  // ---------------------------- GRAPHIC TOPOLOGY ----------------------------
  SAVE_TOPOLOGY_POS_STRING: "Guardar",
  DELETE_TOPOLOGY_POS_STRING: "Eliminar",
  EXPORT_SVG: "SVG",
  EXPORT_TOPOLOGY: "Topología",
  IMPORT_TOPOLOGY: "Importar Topología",
  IMPORT: "Importar",
  EXPORT_PNG: "PNG",
  POSITION: "Posición",
  EXPORT: "Exportar",
  FILTER: "Filtros",
  EXPORT_SVG_POPUP_MSG_1: "Para exportar la imagen de la topología en formato SVG, primero es necesario guardar la posición de la topología.",
  EXPORT_SVG_POPUP_MSG_2: "Para exportar la imagen de la topología en formato SVG, primero es necesario guardar la posición de la topología, como se muestra en la imagen a continuación:",
  EXPORT_SVG_POPUP_MSG_3: "Antes de hacer clic en el botón SVG, asegúrese de que todos los dispositivos de red se muestren dentro del rectángulo, como se muestra en la siguiente figura:",
  EXPORT_SVG_POPUP_MSG_4: "Si algún dispositivo está fuera del área de visualización, como se muestra en la siguiente figura, no aparecerá en el archivo SVG:",

  HIGHER_THAN_20_MBPS: "> 20 Mbps",
  HIGHER_THAN_50_MBPS: "> 50 Mbps",
  WITH_ERROR: "Con error",
  WITH_ERROR_INCREMENT: "Con &Delta; error",
  LEGEND: "Leyenda",

  SAVE_TOPOLOGY_POS_SUCCESS_STRING: "El posicionamiento de la topología se guardó con éxito",
  SAVE_TOPOLOGY_POS_FAILURE_STRING: "Ocurrío el seguinte error al guardar el posicionamiento de la topología: ",

  DROP_TOPOLOGY_POS_SUCCESS_STRING: "El posicionamiento de la topología ha sido removida con éxito",
  DROP_TOPOLOGY_POS_FAILURE_STRING: "Ocurrío el seguinte error al remover el posicionamiento de la topología: ",

  DROPDOWN_NONE: "Ningún",
  DROPDOWN_TRAFFIC: "Tráfico",
  DROPDOWN_ERRORS: "Errores",

  ASK_REMOVE_POSITIONING: "¿Está seguro de que desea eliminar el posicionamiento guardado? Para confirmar la eliminación es necesario ingresar la información de inicio de sesión.",
  REMOVE_POSITIONING: "Remover posicionamiento",
  GRAPHIC_TOPOLOGY_WAITING: "Cargando la topología gráfica",
  YES: "Sí",
  NO: "No",
  USERNAME_PWD_EMPTY: "EL nombre de usuário e contraseña no puedem estar en branco.",

  FORM_INPUT_NOT_FOUND_1: "El dispositivo de IP: ",
  FORM_INPUT_NOT_FOUND_2: " no fue encontrado",
  FORM_INPUT_INVALID_IP: "Digita un dirección ip válida",

  DUPLICATE_IPS: "No se pudo cargar la topología gráfica porque la red contiene direcciones IP duplicadas.",

  DISCONNECTED_PORT_1: "La puerta selecionada ",
  DISCONNECTED_PORT_2: " del dispositivo ",
  DISCONNECTED_PORT_3: " ya no está conectada a ningún dispositivo.",

  TOPOLOGY_IMPORT_SUCCESS: "La topología fue importada con éxito!",
  ERROR_IMPORTING_GRAPHIC_TOPOLOGY: "Ocurrió un errro al importar la topología gráfica: ",
  INVALID_OR_CORRUPT_FILE: "El archivo no es válido o está corrompido.",
  PLEASE_SELECT_TOPOLOGY_FILE: "Por favor seleciona un archivo de topología.",

  GRAPHIC_TOPOLOGY_POPUP_1: "La topología gráfica se detecta automáticamente según la información recibida de los dispositivos de la red y presenta el estado de los equipos según los colores de la LiveList y los enlaces entre los dispositivos cambian de azul a naranja cuando presentan un incremento de error.",
  GRAPHIC_TOPOLOGY_POPUP_2: "Algunos dispositivos no responden a los comandos SNMP utilizados para esta detección, por lo que no todos los dispositivos que se muestran en LiveList estarán presentes en la topología gráfica.",
  GRAPHIC_TOPOLOGY_POPUP_3: "Los diferentes iconos que se muestran dependen de la inclusión de los archivos de configuración de GSDml en la pestaña de configuración de TS Monitor (este archivo debe corresponder al dispositivo presente en la red, de lo contrario no aparecerá el icono correspondiente al tipo).",
  GRAPHIC_TOPOLOGY_POPUP_4: "Las posiciones de los equipos se pueden cambiar, pero no es posible cambiar la conexión entre ellos o agregar equipos.",

  NAME_DP: "Nombre: ",
  MODEL_DP: "Modelo: ",
  PROFINET_TOPOLOGY_JSON: "Topología PROFINET.json",

  // ---------------------------- Log ----------------------------
  ALARM_FAILURE_TOOLTIP: "El mantenimiento debe realizarse ahora. El dispositivo ya no funciona.",
  ALARM_MAINTENANCE_DEMANDED_TOOLTIP: "El mantenimiento debe realizarse lo antes posible.",
  ALARM_MAINTENANCE_REQUIRED_TOOLTIP: "El dispositivo requiere mantenimiento predictivo.",
  ALARM_NONE_TOOLTIP: "Gravedad no informada.",
  INSERT_VALID_EVENT_OR_NAME_OR_IP: "Favor digita un evento, nombre o IP válidos.",
  MANUFACTURER_TIP: " (Consejo del fabricante: ",
  FROM_GSDML: "Del GSDML: ",
  STATUS_CHANGE: "Cambio de estado: ",
  DUPLICATE_IP: "IP duplicado: ",
  DUPLICATE_NAME_DP: "Profiname duplicado: ",

  // ---------------------------- BLACKLIST ----------------------------
  UPDATE_BLACKLIST_DEVICES: "Actualizar dispositivos de la lista negra",
  CONFIRM_UPDATE_BLACKLIST_MODAL_TEXT: "¿Está seguro de que desea actualizar los dispositivos incluidos en la lista negra?",

  ADD_DEVICES_TO_BLACKLIST: "Adicionar dispositivos a la lista negra",
  REMOVE_DEVICES_FROM_BLACKLIST: "Eliminar dispositivos de la lista negra",
  BLACKLIST_FORM_INPUT_PLACEHOLDER: "Filtrar dispositivos por nombre, MAC o IP",
  BLACKLIST_NAME: "Nombre",
  BLACKLIST_MODEL: "Modelo",
  BLACKLIST_MAC: "MAC",
  BLACKLIST_IP: "IP",
  SELECT_ALL: "Selecionar todos",
  REMOVE_SELECTED: "Eliminar selecionados",
  ADD_SELECTED: "Adicionar selecionados",
  ADD_DEVICES_TO_BLACKLIST_SUCCESS: "Los dispositivos han sido adicionados a la lista negra con éxito.",
  ADD_DEVICES_TO_BLACKLIST_FAILURE: "Ocurrió un error al adicionar los seguintes dispositivos a la lista negra:",
  REMOVE_DEVICES_FROM_BLACKLIST_SUCCESS: "Los dispositivos han sido eliminados de la lista negra con éxito.",
  REMOVE_DEVICES_FROM_BLACKLIST_FAILURE: "Ocurrió un error al eliminar los seguintes dispositivos de la lista negra:",
  SELECT_AT_LEAST_ONE_DEVICE: "Seleciona al menos un dispositivo para adicionar a la lista negra.",
  CONFIRM_ADD_TO_BLACKLIST_MODAL_TEXT: "¿Está seguro de que desea agregar los dispositivos seleccionados a la lista negra?",
  CONFIRM_REMOVE_FROM_BLACKLIST_MODAL_TEXT: "¿Está seguro de que desea eliminar los dispositivos seleccionados de la lista negra?",
  IGNORE: "Ignorar",
  LOG_IGNORE: "Log",
  QUESTION_IGNORE: "Monitoreo",
  FAULTS_IGNORE: "Fallas",
  ALARMS_IGNORE: "Alarmas",
  AVAILABILITY_IGNORE: "Disponibilidad",
  SNMP_IGNORE: "SNMP",

  UPDATE_BLACKLIST: "Actualizar lista negra",
  UPDATING_BLACKLIST_WAITING: "Actualizando la lista negra, aguarda un instante",
  UPDATING_BLACKLIST_SUCCESS: "La lista negra ha sido actualiza con éxito",
  BLACKLIST: "Lista negra",

  WHAT_DOES: "Qué hace: ",
  HOW_DOES_IT_APPLY: "Cómo se aplica: ",

  DELTA_ERRORS_TOOLTIP_WHAT: "No comprueba en TS Expert si este dispositivo tiene un incremento de errores, pero sigue contando en la pestaña de tráfico.",
  DELTA_ERRORS_TOOLTIP_HOW: "Útil para RFID, Puntos de Acceso y dispositivos con pérdida de datos intrínseca.",

  LOG_TOOLTIP_WHAT: "Cuenta alarmas y fallas, pero no las inserta en el registro.",
  LOG_TOOLTIP_HOW: "Dispositivos que tienen condiciones anormales que no se pueden resolver.",

  MONITORING_TOOLTIP_WHAT: "No envía ninguna pregunta al dispositivo.",
  MONITORING_TOOLTIP_HOW: "Algunos dispositivos pueden comportarse de manera anormal para los sistemas de monitoreo continuo y pueden fallar.",

  FAULTS_TOOLTIP_WHAT: "No verifica en TS Expert si este dispositivo tiene fallas, pero continúa registrandno y contando en las pestañas LiveList y Log.",
  FAULTS_TOOLTIP_HOW: "Comúnmente utilizado en dispositivos que presentan alarmas normales durante el proceso, como AGVs y otros dispositivos que utilizan fast startup.",

  ALARMS_TOOLTIP_WHAT: "No verifica en TS Expert si este dispositivo tiene alarmas, pero continúa registrando y contabilizando en las pestañas LiveList y Log.",
  ALARMS_TOOLTIP_HOW: "Comúnmente utilizado en dispositivos que presentan alarmas normales durante el proceso, como AGVs y otros dispositivos que utilizan fast startup.",

  AVAILABILITY_TOOLTIP_WHAT: "Ignora el dispositivo para el cálculo de disponibilidad.",
  AVAILABILITY_TOOLTIP_HOW: "Se puede utilizar para dispositivos PROFINET y Ethernet teniendo en cuenta la criticidad del dispositivo para el proceso.",

  SNMP_TOOLTIP_WHAT: "Reduce considerablemente el envío de consultas SNMP al dispositivo.",
  SNMP_TOOLTIP_HOW_1: "Hay casos en los que los dispositivos con bajo rendimiento se sobrecargan al responder consultas SNMP.",
  SNMP_TOOLTIP_HOW_2: "Al colocar el TS Monitor PROFINET en la red, si se detecta que un dispositivo no está funcionando correctamente, agregarlo a esta blacklist reducirá considerablemente la velocidad a la que se envían las consultas SNMP y puede solucionar el problema.",

  BLACKLIST_UPDATE_ERROR: "Ocurrió un error al guardar la información de la lista negra, intente nuevamente",
  BLACKLIST_UPDATE_SUCCESS: "Lista negra actualizada con éxito",

  REQUEST_TOOK_TOO_LONG: "La conexión llevó demasiado tiempo para contestar.\n",
  UNABLE_TO_UPDATE_FOLLOWING_BLACKLISTS: "No se puede actualizar la información de la lista negra para:\n",
  TRY_AGAIN_STRING: "Vuelva a intentarlo.\nNOTA: La información de las otras listas negras se ha actualizado con normalidad",
  ERROR_LIST_DELTA_ERRORS: "- Delta erros;\n",
  ERROR_LIST_LOG: "- Log;\n",
  ERROR_LIST_FAULTS: "- Fallas;\n",
  ERROR_LIST_ALARMS: "- Alarmas;\n",
  ERROR_LIST_AVAILABILITY: "- Disponibilidad;\n",
  ERROR_LIST_MONITORING: "- Monitoreo;\n",
  ERROR_LIST_SNMP: "- SNMP;\n",

  DEVICES_FROM_BLACKLIST_POPUP_1: "Dispositivos de la lista negra de monitoreo aparecerán en otras pantallas en negro",
  DEVICES_FROM_BLACKLIST_POPUP_2: "Los dispositivos de otras listas negras aparecerán en otras pantallas con sus colores del estado",
  DEVICES_FROM_BLACKLIST_POPUP_3: "Los dispositivos de la lista negra de monitoreo aparecen en negro",
  DEVICES_FROM_BLACKLIST_POPUP_4: "Los dispositivos de otras listas negras aparecen con sus colores de estado normales",

  // ---------------------------- Edit GSDML page related ----------------------------
  REMOVE_GSDML_SUCCESS: "Los archivos GSDML han sido eliminados con éxito",
  REMOVE_GSDML_FAILURE: "Ocurrió u error al eliminar los archivos GSDML",
  REMOVE_GSDML_FILES: "Gestionar archivos GSDML",
  FILTER_GSDML: "Filtrar archivos GSDML",
  REMOVING_GSDML_FILES: "Eliminando archivos GSDML",

  // ---------------------------- Device Search related ----------------------------
  MANUAL_SEARCH: "Búsqueda Manual",
  SEARCH_DEVICES: "Buscar dispositivos",
  MANUAL_SEARCH_TURNED_ON_SUCCESS: "La búsqueda manual fue encedida con éxito.",
  MANUAL_SEARCH_TURNED_OFF_SUCCESS: "La búsqueda manual fue apagada con éxito.",
  ERROR_ALTERING_SEARCH_STATE: "Ocurrió un error al alterar el estado de la búsqueda.",
  CHOOSE_SEARCH_QUANTITY: "Por favor escoja la cantidad de búsquedas a realizar.",
  DEVICE_SEARCH_INIT_SUCCESS: "La búsqueda por dispositivos fue iniciada con éxito.",
  DEVICE_SEARCH_INIT_FAILURE: "Ocurrió un error al iniciar la búsquerda por dispostivos.",
  SEARCH: "Buscar",
  SEARCH_NOUN: "Búsqueda",
  SEARCH_MODE: "Tipo de búsqueda",
  MANUAL_SEARCH_TURNED_OFF: "Apagada",
  MANUAL_SEARCH_TURNED_ON: "Encendida",
  QUANTITY_OF_NEW_SEARCHES: "Cantidad de nuevas búsquedas",
  ERROR_FETCHING_SEARCH_STATE: "Ocurrió un error as acesar el estado de la búsqueda.",

  // ---------------------------- PORTS ----------------------------
  PORTS: "Puertas",

  DUPLEX_MODE_1: "Modo",
  DUPLEX_MODE_2: "Duplex",

  INTERFACE_SPEED_1: "Velocidad",
  INTERFACE_SPEED_2: "de la interfaz",

  LINE_DELAY_VALUE_1: "Delay",
  LINE_DELAY_VALUE_2: "Value",

  ACTIVE: "Activo",
  INACTIVE: "Inactivo",

  // ---------------------------- Ping ----------------------------
  MEDIUM_PING: "Ping médio",
  LOST_PACKET_PERC_1: "Pings",
  LOST_PACKET_PERC_2: "Perdidos (%)",
  TENDENCY: "Tendencia",
  EXPORT_CSV: "Exportar XLSX",
  MISSED_PINGS_POPUP: "Cantidad / % de pings perdidos en los últimos 360 pings realizados.",

  // ---------------------------- Ping Graph ----------------------------
  DEVICES_TOOLTIP_1: "Puede ver un máximo de 5 dispositivos al mismo tiempo.",
  DEVICES_TOOLTIP_2: "Los dispositivos con IP duplicados no se muestran hasta que se resuelva el problema.",
  TIME_DP: "Tiempo: ",
  TIME: "Tiempo",
  PING: "Ping",
  PING_GRAPH: "Gráfico de ping",

  // ---------------------------- WLAN Config ----------------------------
  WLAN_STATUS: "Adaptador WLAN",
  WLAN_CONFIG: "Configuraciones WLAN",
  CONNECTION_STATUS: "Estado de la conexión",

  WLAN_ADAPTER_ON: "Encendido",
  WLAN_ADAPTER_OFF: "Apagado",

  IP_PLACEHODLER: "192.168.2.215",
  SSID: "SSID",
  SIGNAL_STRENGTH: "Fuerza de la señal",
  FREQUENCY: "Frecuencia",
  CHANNEL: "Canal",
  QUALITY: "Calidade",

  SSID_PLACEHOLDER: "SSID",
  MAC_PLACEHOLDER: "A0:8C:FD:19:DB:02",
  SIGNAL_STRENGTH_PLACEHOLDER: "90 dBm",
  FREQUENCY_PLACEHOLDER: "2.4GHz",
  CHANNEL_PLACEHOLDER: "1",
  QUALITY_PLACEHOLDER: "Calidade",

  TURNING_WLAN_OFF_WAITING: "Apagando el adaptador WLAN, por favor espere.",
  TURNING_WLAN_ON_WAITING: "Encendendo el adaptador WLAN, por favor espere.",

  NETWORK: "Red",
  NETWORK_NAME_1: "Nombre de la red",
  SUBMASK: "Macarilla",
  GATEWAY: "Gateway",
  DNS: "DNS",
  TAG: "Tag",
  PASSWORD: "Contraseña",
  SETUP: "Configurar",
  YEAR: " año",
  MONTH: " mes",
  MONTHS: " meses",
  DAY: " día",
  HOUR: " hora",
  MINUTE: " minuto",
  SECOND: " segundo",

  ALTER_MONITOR_WLAN_CONFIG: "¿Está seguro de que desea cambiar la configuración WLAN del monitor?",
  ALTER_OFFICE_INTERFACE_CONFIG_HEADER: "Configurar la interfaz office",
  ALTER_OFFICE_INTERFACE_CONFIG: "¿Está seguro de que desea cambiar la configuración de la interfaz office?",
  ALTER_OFFICE_INTERFACE_CONFIG_2: "Cuando utilice el modo DHCP, asegúrese de que la interfaz office no esté configurada en la misma subred que la interfaz PROFINET; de lo contrario, TS Monitor PROFINET puede comportarse de manera diferente a lo esperado.",

  CONNECTED: "Conectada",
  DISCONNECTED: "Desconectada",

  WLAN_STATUS_POPUP_1: "Indica el estado del adaptador WLAN de monitor.",
  WLAN_STATUS_POPUP_2: "Si está apagado, no es posible cambiar la configuración de WLAN.",

  CONNECTION_STATUS_POPUP_1: "Indica si el monitor está conectado o no a la red WLAN configurada.",
  CONNECTION_STATUS_POPUP_1_1: "Indica si el monitor está conectado o no a la red Ethernet configurada.",

  WLAN_CONFIG_POPUP_1: "No es posible cambiar la configuración mientras el adaptador WLAN está apagado.",
  WLAN_CONFIG_POPUP_2: "Se recomienda enfáticamente que la configuración de WLAN se cambie solo cuando se accede al monitor a través de la red cableada.",
  WLAN_CONFIG_POPUP_3: "Al cambiar la IP / mascarilla, si los campos aparecen en blanco después de la actualización, esto es una fuerte indicación de que:",
  WLAN_CONFIG_POPUP_4: "Ya hay otro dispositivo en la red con la misma IP;",
  WLAN_CONFIG_POPUP_5: "La mascarilla de red es muy estricta y no admite la IP que se pasó.",

  WLAN_ADAPTER_NOT_FOUND_1: "TS Monitor PROFINET no pudo encontrar el adaptador WLAN:\n",
  WLAN_ADAPTER_NOT_FOUND_2: "  • Comproba si el adaptador está desconectado, o con mal contacto;\n",
  WLAN_ADAPTER_NOT_FOUND_3: "  • Si el adaptador no está desconectado o tiene mal contacto, intente reemplazarlo.;\n",
  WLAN_ADAPTER_NOT_FOUND_4: "  • Si ninguna de las opciones anteriores resuelve el problema, comuníquese con Toledo e Souza.",

  HOSTNAME_POPUP_1: "Un hostname debe tener entre 2 y 64 caracteres para ser válido.",
  HOSTNAME_POPUP_2: "Además, solo puede contener letras, números, puntos y guiones, y debe comenzar y terminar solo con letras y números.",

  INVALID_HOSTNAME_1: "El nombre de host debe tener entre 2 y 64 caracteres.",
  INVALID_HOSTNAME_2: "El nombre de host debe contener solo letras, números, puntos y guiones, y debe comenzar y terminar solo con letras y números.",

  INVALID_HOSTNAME: "El nombre de host no debe estar en blanco ni contener espacios o caracteres especiales.",
  HOSTNAME_CONFIG_SUCCESS: "El nombre de host se ha configurado con éxito.",
  HOSTNAME_CONFIG_ERROR: "Ocurrió un error al configurar el nombre de host",
  MODE: "Modo",
  HIDDEN_SSID: "SSID Oculto",
  OPTIONAL: " (Opcional)",
  FIXED_IP: "Dirección IP fija",

  // ---------------------------- INVENTORY ----------------------------
  INVENTORY_INPUT_TEXT_PLACEHOLDER: "Filtrar por IP, MAC, nombre o modelo",
  MANUFACTURER: "Fabricante",
  ORDER_NUMBER: "Order number",
  VERSION_OF: "Versión de ",
  IO_CONTROLLER_POPUP_1: "Esta columna muestra a qué IO Controller está asociado el dispositivo.",
  IO_CONTROLLER_POPUP_2: "Es posible que el dispositivo esté:",
  IO_CONTROLLER_POPUP_3: "Asociado con un controlador IO;",
  IO_CONTROLLER_POPUP_4: "Asociado con más de un IO Controller;",
  IO_CONTROLLER_POPUP_5: "NO esté asociado a ningún IO Controller.",

  DEVICE_COUNTERS_POPUP: "Los números al costado indican los totales para cada tipo de equipo.",

  NO_IO_CONTROLLER: "No asociado",
  ASSOCIATED: "asocidado",
  ORDER_NUMBER_N: "Order\nnumber",
  HARDWARE_VERSION_N: "Versión de\nHardware",
  FIRMWARE_VERSION_N: "Versión de\nFirmware",
  IO_CONTROLLER: "IO Controller",

  INVENTORY_CSV_HEADER: "Nombre,MAC,IP,Función,Modelo,Fabricante,Order number,Versión de hardware,Versión de firmware,IO Controller asociado\n",
  INVENTORY_EXPORT_NAME: "Inventario.xlsx",

  // ---------------------------- TS EXPERT CONFIG ----------------------------
  CURRENT_VALUE_DP: "Valor actual: ",
  SAVE: "Guardar",
  SENDING_TS_EXPERT_CONFIG_WAITING: "Actualizando la configuración de TS Expert, espere un momento.",
  TS_EXPERT_CONFIG_SAVED_SUCCESSFULLY: "La configuración de TS Expert se ha guardado con éxito.",
  TS_EXPERT_CONFIG_SAVE_ERROR: "Ocorrió un error al guardar las configuraciones de TS Expert.",

  TS_EXPERT_CONFIGURATION: "Configuraciones del TS Expert",

  CONFIG_DIAGNOSTIC_LIST_HEADER: "Alarmas",
  CONFIG_DIAGNOSTIC_LIST_CONTENT: "Si está activado, TS Expert registrará cada vez que un dispositivo PROFINET tenga alarmas. La alarma es una condición anormal o información de mal funcionamiento enviada por el dispositivo IO al controlador IO, solicitando mantenimiento o incluso reemplazo.",

  CONFIG_FAULT_LIST_HEADER: "Fallas",
  CONFIG_FAULT_LIST_CONTENT: "Si está activado, TS Expert registrará cada vez que un dispositivo PROFINET tenga fallas. Esto indica que no responde a los comandos ping y arp a través de la red, es decir, no es accesible a través de la red.",

  CONFIG_DUPLICATE_NAME_LIST_HEADER: "Profiname duplicado",
  CONFIG_DUPLICATE_NAME_LIST_CONTENT: "Si está activado, TS Expert registrará cada vez que se configuren dos dispositivos con el mismo nombre de perfil. Esto puede causar fallas en la comunicación.",

  CONFIG_DUPLICATE_IP_LIST_CONTENT: "Si está activado, TS Expert registrará cada vez que se detecte una IP duplicada en la red.",

  CONFIG_EXCEEDED_PING_LIST_HEADER: "Tiempo de ping excedido",
  CONFIG_EXCEEDED_PING_LIST_CONTENT: "Si está activado, TS Expert registrará cada vez que el ping promedio de un dispositivo exceda el valor límite de ping.",

  CONFIG_ERROR_INCREMENT_LIST_HEADER: "Incrementos de error",
  CONFIG_ERROR_INCREMENT_LIST_CONTENT: "Si está activado, TS Expert registrará cada vez que un dispositivo tenga un incremento de paquetes con errores de entrada y/o salida en cualquiera de sus puertas.",

  CONFIG_DUPLEX_LIST_HEADER: "Puerta configurada en modo Dúplex y/o velocidad no recomendada",
  CONFIG_DUPLEX_LIST_CONTENT: "Si está activado, TS Expert registrará cada vez que la configuración de una puerta sea diferente de: Full Duplex a 100 Mbps o Full Duplex a 1000 Mbps (Las puertas configurados en Half Duplex tienden a generar colisiones y pérdida de paquetes, lo cual es un problema para un servidor real). -Protocolo de control e intercambio de datos en tiempo (los enlaces configurados a 10 Mbps pueden convertirse en obstáculos en la comunicación e impedir la transmisión de paquetes).",

  CONFIG_TRAFFIC_EXCEEDED_LIST_HEADER: " Exceso de tráfico de entrada / salida",
  CONFIG_TRAFFIC_EXCEEDED_LIST_CONTENT: "Si está activado, TS Expert registrará cada vez que se detecte un tráfico total superior a 50 Mbps en una puerta determinado.",

  CONFIG_INACTIVE_PORT_LIST_HEADER: "Puerta inactivada",
  CONFIG_INACTIVE_PORT_LIST_CONTENT: "Si está activado, TS Expert registrará cada vez que se deshabilite una puerta activa, ya sea desconectando o rompiendo un cable, o apagando o desconectando el dispositivo en el extremo opuesto del cable. Podrá indicar un problema con el cable, el conector, el dispositivo en el extremo opuesto o incluso la electrónica del dispositivo que tenía la puerta deshabilitada.",

  HW_FW_PORT_LIST_HEADER: "Versión de hardware igual y firmware diferente",
  HW_FW_PORT_LIST_CONTENT: "Si está activado, TS Expert registrará cada vez que se detecten dispositivos con las mismas versiones de hardware pero diferentes versiones de firmware. Estos dispositivos pueden tener diferente funcionalidad, características y comportamiento. Este indicador tiene como objetivo cruzar información sobre fallas que pueden estar ocurriendo de forma aislada en uno u otro dispositivo y que pueden estar relacionadas con las versiones de firmware.",

  CONFIG_ERROR_CONFIG_LIST_HEADER: "Módulo diferente de configurado",
  CONFIG_ERROR_CONFIG_LIST_CONTENT: "Si está activado, TS Expert registrará cada vez que se detecte un módulo diferente al configurado. Este fallo de configuración ocurre cuando el módulo declarado en el software de configuración es diferente al instalado físicamente en el IO Device.",

  DUPLEX_MISMATCH_CONFIG_LIST_HEADER: "Incompatibilidad del modo Duplex",
  DUPLEX_MISMATCH_CONFIG_LIST_CONTENT: "Si está activado, el TS Expert registrará todos los enlaces que regresaron con información Duplex y son incompatibles entre sí, por ejemplo, uns puerta Half Duplex conectado a otro en Full Duplex.",

  DELAY_EXCEEDED_CONFIG_LIST_HEADER: "Delay",
  DELAY_EXCEEDED_CONFIG_LIST_CONTENT: "Si está activado, TS Expert registrará todos los enlaces que regresaron con valores de retraso de enlace o cable mayores que los recomendados por las pautas de PROFINET.",

  CONFIG_INTERMITTENT_FAILURE_LIST_HEADER: "Fallas intermitentes",
  CONFIG_INTERMITTENT_FAILURE_LIST_CONTENT: "Si está activado, TS Expert registrará fallas intermitentes de los dispositivos PROFINET. Esto indica que está perdiendo la comunicación y recuperándose rápidamente.",

  CONFIG_LOST_IP_LIST_HEADER: "Pérdida de dirección IP",
  CONFIG_LOST_IP_LIST_CONTENT: "Si está activado, TS Expert registrará cada vez que se detecte un dispositivo con una posible pérdida de dirección IP (0.0.0.0).",

  PING_LIMIT: "Ping límite",
  ALTER_PING_LIMIT_SUCCESS: "O ping límite fue alterado con éxito.",
  ALTER_PING_LIMIT_ERROR: "Ocurrió un error al alterar el ping límite.",

  PING_LIMIT_POPUP_1: "El ping límite es el valor de ping promedio por encima del cual se considera que el dispositivo tiene un problema. Si esto ocurre, se creará un evento en TS Expert.",
  PING_LIMIT_POPUP_2: "Cada vez que un dispositivo exceda este valor, se creará un evento en TS Expert.",
  PING_LIMIT_POPUP_3: "La unidad de medida del ping es milissegundos (ms).",
  PING_LIMIT_POPUP_4: "El valor mínimo permitido para el ping límite es de 0 ms.",
  PING_LIMIT_POPUP_5: "El valor máximo permitido para el ping límite es de 10.000 ms (10 segundos).",

  PING_LIMIT_OUT_OF_BOUNDS: "El ping límite necesita estar entre 0 y 10.000 ms (10 segundos).",

  // ---------------------------- TS EXPERT ----------------------------
  TS_EXPERT_REPORT_EXPORT_NAME: "Lista de aciones - TS Expert - PROFINET",

  TS_EXPERT_POPUP_1: "Esta pestaña muestra la información de TS Expert.",
  TS_EXPERT_POPUP_2: "Esta herramienta es un sistema experto desarrollado para optimizar y acelerar el análisis de las principales divergencias detectadas por TS Monitor en redes PROFINET.",
  TS_EXPERT_POPUP_3: "De forma automatizada, los equipos de mantenimiento, ingeniería y afines pueden obtener una lista de acciones con diferentes eventos, sus posibles causas, sugerencias de solución y los dispositivos en los que fueron detectados.",
  TS_EXPERT_POPUP_4: "El uso de TS Expert no excluye la necesidad de análisis humano, ni reemplaza dichas capacidades para crear correlaciones e interpretación de datos.",

  TS_EXPERT: "TS Expert",
  DETECTED_ON: "Detectado en: ",
  CHECK_YOUR_NETWORK: "Por favor verifica su red.",

  EXPORT_ACTIONS_LIST: "Exportar lista de aciones",
  GENERATING_ACTIONS_LIST_WAITING: "Generando PDF de lista de aciones, por favor espera.",
  GENERATING_ACTIONS_LIST_SUCCESS: "PDF generado con éxito. Para guardarlo, haga clic en Guardar lista de acciones.",

  EVENTS_LIST: "Lista de eventos",
  ACTIONS: "Aciones",

  NO_PROBLEM_DETECTED: "El TS Expert no ha detectado ningún evento en la red.",
  NO_EVENTS_TO_BE_ANALYZED: "No hay eventos para analizar.",

  NO_EVENT_SELECTED: "Ningún evento selecionado",
  CHOOSE_AN_EVENT: "Elija un evento para ver las acciones sugeridas.",

  DETAILING: "Detalles",

  CHECKED: "Conferido",
  BATCH_CHECK: "Conferir todos",

  PROBLEM_CHECKED: "El evento ha sido conferido con éxito",
  PROBLEM_CHECK_ERROR: "Ocurrió un error al conferir el evento.",

  QUANTITY_DP: "Cantidad: ",
  INCREMENTS: "Incrementos",

  PORT_IS_STILL_INACTIVE: "La puerta sigue inactiva",
  MARK_PROBLEM_AS_SOLVED: "¿Está seguro de que desea marcar el evento como conferido?",

  LAST_UPDATED: "Actualizado por la última vez en: ",
  THIS_COMPUTER_TIME: " (Tiempo de esta computadora)",

  RECEIVED_INFO: "Informaciones recebidas",
  EXPECTED_INFO: "Informaciones esperadas",

  RECEIVED_INFO_DP: "Informaciones recebidas:",
  EXPECTED_INFO_DP: "Informaciones esperadas:",

  MODULE_NUMBER_DP: "Nombre del módulo:",
  ALL_EVENTS_WERE_CHECKED: "Todos los eventos han sido conferidos con éxito.",
  CHECK_EVENT_OBS: "\nEs importante tener en cuenta que algunos datos tardan hasta 15 minutos en actualizarse, por lo tanto, se sugiere esperar un tiempo para borrar esta lista haciendo clic en conferir.\n",
  ACTIONS_LIST_NAME: "Lista de aciones - TS Expert - PROFINET.pdf",
  SAVE_ACTIONS_LIST: "Guardar lista de aciones",
  ACTIONS_LIST: "Lista de aciones",

  UNABLE_TO_CHECK_ALARMS_EVENT: "No se puede verificar el evento del dispositivo porque todavía tiene alarmas activas\n",
  UNABLE_TO_CHECK_FAULT_EVENT: "No se puede verificar el evento del dispositivo porque todavía está en estado de falla\n",
  UNABLE_TO_CHECK_DUPLICATE_IP_EVENT: "No se puede verificar el evento del dispositivo porque todavía tiene una IP duplicada\n",
  UNABLE_TO_CHECK_DUPLICATE_NAME_EVENT: "No se puede verificar el evento del dispositivo porque todavía tiene un profiname duplicado\n",
  UNABLE_TO_CHECK_PING_LIMIT_EVENT: "No se puede verificar el evento del dispositivo porque el valor de ping promedio permanece por encima del valor de límite de ping configurado\n",
  UNABLE_TO_CHECK_DELTA_ERROR_EVENT: "No se puede verificar el evento del dispositivo porque tiene puertas con incrementos de error\n",
  UNABLE_TO_CHECK_NOT_IN_FULL_DUPLEX_EVENT: "No se puede verificar el evento del dispositivo porque su puerta todavía está configurado en un modo o velocidad dúplex no recomendado\n",
  UNABLE_TO_CHECK_TRAFFIC_EXCESS_EVENT: "No se puede verificar el evento del dispositivo porque el tráfico en los siguientes puertas aún supera los 50 Mbps\n",
  UNABLE_TO_CHECK_INACTIVE_PORT_EVENT: "No se puede verificar el evento del dispositivo, ya que su puerta permanece inactiva (estaba activa y ahora se vuelvió inactiva)\n",
  UNABLE_TO_CHECK_HW_FW_EVENT: "No fue posible verificar el evento, ya que los dispositivos aún tienen versiones de firmware diferentes\n",
  UNABLE_TO_CHECK_MODULE_INCOHERENCE_EVENT: "No se puede verificar el evento del dispositivo porque todavía tiene módulos diferentes a los declarados en el software de configuración\n",
  UNABLE_TO_CHECK_DUPLEX_MISMATCH_EVENT: "No se puede verificar el evento del dispositivo porque todavía tiene incompatibilidad con el modo dúplex\n",
  UNABLE_TO_CHECK_DELAY_EXCEEDED_EVENT: "No se puede comprobar el evento del dispositivo porque su puerta todavía supera el valor límite de retraso\n",
  UNABLE_TO_CHECK_INTERMITTENT_FAILURE_EVENT: "No se puede verificar el evento del dispositivo porque todavía tiene fallas intermitentes\n",
  UNABLE_TO_CHECK_LOST_IP_EVENT: "No se puede verificar el evento del dispositivo, ya que aún presenta una posible pérdida de direccíon IP\n",

  UNABLE_TO_CHECK_ALARMS_EVENTS: "No se pueden verificar los eventos de los siguientes dispositivos porque todavía tienen alarmas activas:\n",
  UNABLE_TO_CHECK_FAULT_EVENTS: "No fue posible verificar los eventos de los siguientes dispositivos ya que todavía están en estado de falla:\n",
  UNABLE_TO_CHECK_DUPLICATE_IP_EVENTS: "No se pueden verificar los eventos de los siguientes dispositivos porque todavía tienen una IP duplicada:\n",
  UNABLE_TO_CHECK_DUPLICATE_NAME_EVENTS: "No se pueden conferir los eventos de los siguientes dispositivos porque todavía están con profinames duplicados:\n",
  UNABLE_TO_CHECK_PING_LIMIT_EVENTS: "No se pueden verificar los eventos de los siguientes dispositivos porque los valores promedio de ping aún están por encima del valor límite de ping configurado:\n",
  UNABLE_TO_CHECK_DELTA_ERROR_EVENTS: "No se pueden conferir los eventos de los siguientes dispositivos porque tienen puertas con incrementos de error:\n",
  UNABLE_TO_CHECK_NOT_IN_FULL_DUPLEX_EVENTS: "No se pueden comprobar los eventos de los siguientes dispositivos porque sus puertas aún están configurados en un modo o velocidad dúplex no recomendados:\n",
  UNABLE_TO_CHECK_TRAFFIC_EXCESS_EVENTS: "No se pueden comprobar los eventos de los siguientes dispositivos porque el tráfico en las siguientes puertas todavía supera los 50 Mbps:\n",
  UNABLE_TO_CHECK_INACTIVE_PORT_EVENTS: "No fue posible verificar los eventos de los siguientes dispositivos, ya que sus puertas aún están inactivas (estaba activa y se volvió inactiva):\n",
  UNABLE_TO_CHECK_HW_FW_EVENTS: "No fue posible verificar los eventos de los siguientes dispositivos, ya que todavía tienen las mismas versiones de hardware, pero con diferentes versiones de firmware:\n",
  UNABLE_TO_CHECK_MODULE_INCOHERENCE_EVENTS: "No fue posible verificar los eventos de los siguientes dispositivos, ya que todavía tienen módulos diferentes a los declarados en el software de configuración:\n",
  UNABLE_TO_CHECK_DUPLEX_MISMATCH_EVENTS: "No se pueden comprobar los eventos de los siguientes dispositivos porque aún tienen incompatibilidad con el modo dúplex:\n",
  UNABLE_TO_CHECK_DELAY_EXCEEDED_EVENTS: "No se pueden comprobar los eventos de los siguientes dispositivos porque sus puertas todavía superan el valor límite de retraso:\n",
  UNABLE_TO_CHECK_INTERMITTENT_FAILURE_EVENTS: "No se pueden verificar los eventos de los siguientes dispositivos porque todavía tienen fallas intermitentes:\n",
  UNABLE_TO_CHECK_LOST_IP_EVENTS: "No se pueden verificar los eventos de los siguientes dispositivos, ya que aún presentan una posible pérdida de dirección IP:\n",

  HARDWARE_VERSION: "Versión del hardware",

  // ---------------------------- DIAGNOSTICS ----------------------------
  DIAGNOSTIC_LIST_HEADER: "Hay dispositivos en la red que tienen alarmas.",
  DEVICE_WITH_DIAGNOSTIC: "Dispositivo con alarma",

  DIAGNOSTIC_SUGGESTION_1: "Cuando un dispositivo tiene alarmas se sugiere:",
  DIAGNOSTIC_SUGGESTION_2: "Comprueba la información enviada por el propio IO Device (detectada y transformada en texto por el TS Monitor) e intente solucionar el problema. Si tiene dificultad para comprender el diagnóstico, comuníquese con el fabricante del dispositivo o consulte el manual del dispositivo IO para despejar sus dudas antes de una intervención.",

  NO_DEVICE_WITH_DIAGNOSTIC: "No hay dispositivos en la red con alarmas activas",

  // ---------------------------- FAULTS ----------------------------
  FAULTS_LIST_HEADER: "Hay dispositivos en la red que tienen fallas.",
  DEVICE_WITH_FAULT: "Dispositivo con falla",

  FAULT_SUGGESTION_1: "Cuando un dispositivo tiene fallas se sugiere:",
  FAULT_SUGGESTION_2: "Verifique la alimentación del dispositivo IO;",
  FAULT_SUGGESTION_3: "Verifique que esté conectado físicamente a la red;",
  FAULT_SUGGESTION_4: "Verifique la integridad del conector;",
  FAULT_SUGGESTION_5: "Verifique la integridad del cable;",
  FAULT_SUGGESTION_6: "Verifica si el dispositivo ha perdido su dirección IP. En caso de que esto suceda, el dispositivo aparecerá en el monitor con la IP: 0.0.0.0, su IP también estará marcada en naranja en la Live List.",

  NO_DEVICE_WITH_FAULT: "No hay dispositivos con falla en la red.",

  // ---------------------------- DUPLICATE IP ----------------------------
  DUPLICATE_IP_LIST_HEADER: "Hay dispositivos en la red con IP duplicada.",
  DEVICES_WITH_DUPLICATE_IP: "Dispositivos con IP duplicada",

  DUPLICATE_IP_CARD_DESC: "Los siguientes dispositivos están utilizando la dirección IP: ",

  DUPLICATE_IP_SUGGESTION_1: "Cuando hay IP duplicadas en la red, se sugiere:",
  DUPLICATE_IP_SUGGESTION_2: "Verifique las direcciones físicas, MAC, para identificar los dispositivos que tienen conflictos de dirección IP y corregir las configuraciones de esta dirección.",

  NO_DEVICES_WITH_DUPLICATE_IPS: "No hay dispositivos en la red con IP duplicadas",

  // ---------------------------- DUPLICATE NAME ----------------------------
  DUPLICATE_NAME_LIST_HEADER: "Hay dispositivos en la red con profiname duplicado.",
  DEVICES_WITH_DUPLICATE_NAME: "Dispositivos con profiname duplicado",

  DUPLICATE_NAME_CARD_DESC: "Los siguientes dispositivos utilizan el nombre: ",

  DUPLICATE_NAME_SUGGESTION_1: "Cuando hay dispositivos en la red con profiname duplicado, se sugiere:",
  DUPLICATE_NAME_SUGGESTION_2: "Verifique el proyecto y cambie el dispositivo IO que tiene el profiname incorrecto.",

  NO_DEVICES_WITH_DUPLICATE_NAMES: "No hay dispositivos en la red con profiname duplicado",

  // ---------------------------- PING LIMIT ----------------------------
  GROUP_PING_LIMIT_HEADER: "Hay dispositivos en la red que han excedido el valor límite de ping.",
  PING_LIMIT_EXCEEDED: "Límite de ping excedido",

  REGISTERED_PING: "Ping registrado: ",

  PING_LIMIT_SUGGESTION_1: "Cuando un dispositivo supera el límite de ping, se sugiere:",
  PING_LIMIT_SUGGESTION_2: "Problemas de tráfico:",
  PING_LIMIT_SUGGESTION_3: "Use la pestaña Tráfico y revise las aplicaciones que están usando el enlace, vea si están de acuerdo con la infraestructura disponible;",
  PING_LIMIT_SUGGESTION_4: "Verifique si el ancho de banda disponible cumple con la aplicación (usando conmutadores Fast o Gigabit Ethernet).",

  PING_LIMIT_SUGGESTION_5: "Alto uso de equipos de procesamiento y switches:",
  PING_LIMIT_SUGGESTION_6: "Revisar el consumo de datos de la aplicación;",
  PING_LIMIT_SUGGESTION_7: "Revisar la temperatura de los dispositivos.",

  PING_LIMIT_SUGGESTION_8: "Retraso de propagación (longitud de cable excesiva):",
  PING_LIMIT_SUGGESTION_9: "Identifique la longitud del cable, visualmente cuando esté grabado en el cable, o usando probadores o certificadores.",

  NO_DEVICE_EXCEEDED_PING_LIMIT: "No hay dispositivos en la red que hayan excedido el valor del umbral de ping",

  // ---------------------------- DELTA ERROR ----------------------------
  DELTA_ERROR_LIST_HEADER: "Hay dispositivos en la red con puertas que tienen incrementos de error.",
  DELTA_ERROR_ALARM: "Incrementos de error",
  DEVICE_HAS_DELTA_ERROR_PROBLEMS: "El dispositivo tiene incrementos de error en las siguientes puertas:",

  DELTA_ERRORS_SUGGESTION_1: "Cuando un dispositivo tiene puertas que tienen incrementos de error, se sugiere:",
  DELTA_ERRORS_SUGGESTION_2: "Errores en la entrada",
  DELTA_ERRORS_SUGGESTION_3: "Verifique si hay incompatibilidad de dúplex (una puerta 100 Mbps Full Duplex conectada a una puerta 10 Mbps Half Duplex). Los enlaces deben tener la misma configuración en ambos extremos y, preferiblemente, utilizar la negociación automática;",
  DELTA_ERRORS_SUGGESTION_4: "Verificar si los recorridos de cable de datos en bandejas portacables, conductos y bandejas están cerca de cableado de potencia, drives y otros dispositivos de mayor consumo cuyo cableado pueda generar interferencias. Los cables de red deben estar lo más alejados posible o en conductos aislados y puestos a tierra;",
  DELTA_ERRORS_SUGGESTION_5: "Verifique la calidad de los enlaces Ethernet. Conectores mal ensamblados, cables y conectores de mala calidad pueden generar pérdidas;",
  DELTA_ERRORS_SUGGESTION_6: "Usando un certificador, verifique que los cables estén intactos y sean capaces de funcionar para la categoría (Cat5, Cat5e, Cat6, etc.).",
  DELTA_ERRORS_SUGGESTION_7: "Errores en la salida",
  DELTA_ERRORS_SUGGESTION_8: "Verifique si hay incompatibilidad de dúplex (una puerta 100 Mbps Full Duplex conectada a una puerta 10 Mbps Half Duplex). Los enlaces deben tener la misma configuración en ambos extremos y preferiblemente utilizar la negociación automática;",
  DELTA_ERRORS_SUGGESTION_9: "Verifique la calidad de los enlaces Ethernet. Conectores mal ensamblados, cables y conectores de mala calidad pueden generar pérdidas;",
  DELTA_ERRORS_SUGGESTION_10: "Verifique posibles problemas con la interfaz de red del dispositivo, que requieran reemplazo si se detectan.",

  DEVS_WITH_DELTA_ERRORS_EXPLANATION_1: "En esta lista, solo se muestran los dispositivos y las respectivas puertas que tienen incrementos de error de entrada o salida.",
  DEVS_WITH_DELTA_ERRORS_EXPLANATION_2: "Los contadores de errores que tienen un incremento se resaltarán en naranja.",

  NO_DEVICE_WITH_DELTA_ERRORS_LIMIT: "No hay dispositivos en la red con puertas que tengan incrementos de error",

  // ---------------------------- NOT IN FULL DUPLEX ----------------------------
  NOT_IN_FULL_DUPLEX_LIST_HEADER: "Hay dispositivos en la red con puertas configurados en modo Duplex y/o velocidad no recomendada.",
  PORT_NOT_IN_FULL_DUPLEX: "Puerta configurados en modo Duplex y/o velocidad no recomendada.",

  DUPLEX_MODE: "Modo Duplex",

  NOT_IN_FULL_DUPLEX_SUGGESTION_1: "Cuuando una puerta está configurado en modo Duplex y/o velocidad no recomendada, se sugiere:",
  NOT_IN_FULL_DUPLEX_SUGGESTION_2: "Verifique si las puertas tienen habilitada la función de negociación automática. Si es fijo, se sugiere cambiar a una velocidad de transmisión de al menos 100Mb y modo Duplex como Full Duplex.",
  NOT_IN_FULL_DUPLEX_SUGGESTION_3: "Si la opción de negociación automática está habilitada y el enlace permanece en Half Duplex, se sugiere cambiar el cableado y, si esta opción no conduce a la negociación de Full Duplex, se pueden cambiar las interfaces de red.",

  NO_DEVICES_WITHOUT_FULL_DUPLEX: "No hay dispositivos en la red con puertas configuradas en modo Dúplex y/o velocidad no recomendada",

  // ---------------------------- TRAFFIC EXCESS ----------------------------
  TRAFFIC_EXCESS_LIST_HEADER: "Hay dispositivos en la red con puertas que superan los 50 Mbps de tráfico.",
  TRAFFIC_EXCESS: "Tráfico superó los 50 Mbps",
  DEVICE_HAS_TRAFFIC_EXCESS_ERROR_PROBLEMS: "El dispositivo ha superado los 50 Mbps de tráfico en las siguientes puertas:",

  TRAFFIC_EXCESS_SUGGESTION_1: "Cuando un dispositivo tiene puertas que superan los 50 Mbps de tráfico entrante o saliente:",
  TRAFFIC_EXCESS_SUGGESTION_2: "Las directrizes del PROFINET indican un tráfico aceptable de hasta el 20 % (o 20 Mbps en enlaces de 100 Mb), un tráfico a revisar entre un 20 y 50 % y la necesidad de una acción inmediata en caso de que el tráfico supere el 50 %. Cuando el tráfico detectado es superioor a 50Mbps, se sugiere:",
  TRAFFIC_EXCESS_SUGGESTION_3: "Estudiar la factibilidad de aumentar el tiempo de ciclo de respuesta de IO Devices (considerar tiempos de proceso, seguridad, etc.);",
  TRAFFIC_EXCESS_SUGGESTION_4: "Dividir dispositivos en diferentes subredes y controladores;",
  TRAFFIC_EXCESS_SUGGESTION_5: "Analice la topología y verifique la posibilidad de crear nuevas rutas para cierto tráfico superior, por ejemplo, agregando switches;",
  TRAFFIC_EXCESS_SUGGESTION_6: "Verifique el origen de este tráfico y si existe la necesidad de que este dispositivo se esté comunicando en la red PROFINET (aísle los dispositivos que realizan el control de otros que se utilizan para el mantenimiento, colecta de datos o cualquier otra tarea que no opere en tiempo real ).",

  DEVS_WITH_TRAFFIC_EXCESS_EXPLANATION_1: "Esta lista solo muestra los dispositivos y sus puertas cuyo tráfico entrante o saliente supera los 50 Mbps.",
  DEVS_WITH_TRAFFIC_EXCESS_EXPLANATION_2: "El tráfico que supere los 50 Mbps se resaltará en naranja.",

  NO_DEVICE_WITH_TRAFFIC_EXCESS: "No Hay dispositivos en la red con puertas que superan los 50 Mbps de tráfico.",

  INPUT_TRAFFIC_KBPS: "Tráfico en la\nentrada (Kbps)",
  OUTPUT_TRAFFIC_KBPS: "Tráfico en la\nsalida (Kbps)",

  // ---------------------------- INACTIVE PORT ----------------------------
  INACTIVE_PORT_LIST_HEADER: "Hay dispositivos en la red cuyas puertas han sido deshabilitados.",
  INACTIVE_PORT: "Puerta inactivada",

  INACTIVE_PORT_SUGGESTION_1: "Cuando una puerta está inactiva (estaba activa y se volvió inactiva)\n, se sugiere:",
  INACTIVE_PORT_SUGGESTION_2: "Verificar cable y conector (en ambos extremos), alimentación del equipo conectado en el extremo opuesto y rotura de cable. Como último recurso, se sugiere reemplazar el módulo.",

  NO_DEVICES_WITH_INACTIVE_PORTS: "No Hay dispositivos en la red cuyas puertas han sido deshabilitados.",

  // ---------------------------- HARDWARE / FIRMWARE ----------------------------
  HW_FW_LIST_HEADER: "Hay dispositivos en la red con las mismas versiones de hardware pero diferentes versiones de firmware.",
  HW_FW: "Mismas versiones de hardware y diferente firmware",
  SAME_HW_DIFF_FW: "Los dispositivos a continuación tienen las mismas versiones de hardware, pero diferentes versiones de firmware",
  FIRMWARE: "Firmware",

  HW_FW_SUGGESTION_1: "Cuando dos dispositivos tienen la misma versión de hardware pero diferentes versiones de firmware, se sugiere:",
  HW_FW_SUGGESTION_2: "Actualice el firmware de estos dispositivos para que sean todos iguales para mantener la estabilidad de la red y la funcionalidad del dispositivo.",
  HW_FW_SUGGESTION_3: "Es muy importante realizar esta operación fuera de producción y consultar al fabricante del dispositivo antes de iniciar esta tarea para evitar incompatibilidades y problemas de funcionamiento.",

  NO_DIFF_HW_FW: "No Hay dispositivos en la red con las mismas versiones de hardware pero diferentes versiones de firmware.",

  // ---------------------------- MODULE INCOHERENCE ----------------------------
  MODULE_INCOHERENCE_LIST_HEADER: "Hay dispositivos en la red con módulos diferentes a los declarados en el software de configuración.",
  MODULE_INCOHERENCE: "Módulo diferente al declarado en el software de configuración",
  INCOHERENCE_IN_MODULE: "Diferencia detectada en el siguiente módulo",

  MODULE_INCOHERENCE_SUGGESTION_1: "Cuando el dispositivo posea módulos distintos a los declarados en el software de configuración, se sugiere:",
  MODULE_INCOHERENCE_SUGGESTION_2: "Verifique la configuración e instalación para subsanar la discrepancia reportada por el dispositivo.",

  NO_DIFF_MODULES: "No Hay dispositivos en la red con módulos diferentes a los declarados en el software de configuración.",
  MODULE: "Módulo",

  // ---------------------------- DUPLEX MISMATCH ----------------------------
  DUPLEX_MISMATCH_LIST_HEADER: "Hay dispositivos en la red con incompatibilidad del modo dúplex.",
  DUPLEX_MISMATCH: "Incompatibilidad de modo Duplex",

  DUPLEX_MISMATCH_SUGGESTION_1: "Cuando dos dispositivos tuvieron incompatibilidad de modo Duplex se sugiere:",
  DUPLEX_MISMATCH_SUGGESTION_2: "Verificar la configuración de las puertas en ambos extremos para ver si están en negociación automática o si están forzados en alguna condición con el modo Duplex ;",
  DUPLEX_MISMATCH_SUGGESTION_3: "Si ambas puertas están en negociación automática, se sugiere probar la integridad del cableado;",
  DUPLEX_MISMATCH_SUGGESTION_4: "Como último recurso, reemplace la interfaz de red del dispositivo.",

  NO_DEVICES_WITH_DUPLEX_MISMATCH: "No hay dispositivos en la red con incompatibilidad del modo dúplex.",

  // ---------------------------- DELAY EXCEEDED ----------------------------
  DELAY_EXCEEDED_LIST_HEADER: "Hay dispositivos en la red con alteración de delay.",
  DELAY_EXCEEDED: "Alteración de delay",

  DELAY_EXCEEDED_SUGGESTION_1: "Cuando un dispositivo tiene alteración de delay se sugiere:",
  DELAY_EXCEEDED_SUGGESTION_2: "Para el caso de Cable Delay alterado, se sugiere verificación del medio físico, certificando los enlaces, verificando la longitud de los cables (se puede identificar por la numeración del metraje grabado en el cable), correcto montaje de los conectores y calidad y categoría (mínimo Cat5) de los elementos utilizados en esta infraestructura;",
  DELAY_EXCEEDED_SUGGESTION_3: "En el caso de un Line Delay alterado, la sugerencia anterior es válida y, si no da resultados, se sugiere reemplazar las interfaces de red, ya que este parámetro indica los tiempos no solo en el cable, sino también en el receptor y transmisor juntos;",

  // ---------------------------- INTERMITTENT FAULTS ----------------------------
  INTERMITTENT_FAILURES_LIST_HEADER: "Hay dispositivos en la red que tienen fallas intermitentes.",
  DEVICE_WITH_INTERMITTENT_FAILURE: "Dispositivo con falla intermitente",

  INTERMITTENT_FAILURES_SUGGESTION_1: "Cuando un dispositivo tiene fallas intermitentes se sugiere:",
  INTERMITTENT_FAILURES_SUGGESTION_2: "Verifique la alimentación del dispositivo IO;",
  INTERMITTENT_FAILURES_SUGGESTION_3: "Verifique la integridad del conector;",
  INTERMITTENT_FAILURES_SUGGESTION_4: "Verifique la integridad del cable.",

  NO_DEVICE_WITH_INTERMITTENT_FAILURE: "No hay dispositivos con fallas intermitentes en la red.",

  // ---------------------------- LOST IP ----------------------------
  LOST_IP_LIST_HEADER: "Hay dispositivos con posible pérdida de IP en la red.",
  LOST_IP_DESCR: "Por favor verifique su red.",
  DEVICE_WITH_LOST_IP: "Dispositivo con posible pérdida de IP",

  LOST_IP_SUGGESTION_1: "Cuando un dispositivo presenta una posible pérdida de dirección IP, se sugiere:",
  LOST_IP_SUGGESTION_2: "Verifique las direcciones físicas, MAC, para identificar los dispositivos que tienen conflictos de dirección IP y corregir las configuraciones de esta dirección.",

  // ---------------------------- EXPERT REPORT ----------------------------
  DIAGNOSTIC_PAGE_TITLE: ". - Dispositivo con alarma",
  FAULT_PAGE_TITLE: ". - Dispositivo con falla",
  DUPLICATE_IP_PAGE_TITLE: ". - Dispositivos con IP duplicado",
  DUPLICATE_NAME_PAGE_TITLE: ". - Dispositivos con profiname duplicado",
  PING_LIMIT_EXCEEDED_PAGE_TITLE: ". - Límite de ping excedido",
  DELTA_ERROR_ALARM_PAGE_TITLE: ". - Incrementos de error",
  PORT_NOT_IN_FULL_DUPLEX_PAGE_TITLE: ". - Puerta configurada en un modo Duplex y/o velocidad no recomendados",
  TRAFFIC_EXCESS_PAGE_TITLE: ". - Tráfico superó 50 Mbps",
  INACTIVE_PORT_PAGE_TITLE: ". - Puerta inactivada",
  HW_FW_TITLE: ". - Versiones de hardware iguales y firmware diferentes",
  MODULE_INCOHERENCE_TITLE: ". - Módulo diferente del declarado en el software de configuración",
  DUPLEX_MISMATCH_PAGE_TITLE: ". - Incompatibilidad de modo Duplex",
  DELAY_EXCEEDED_PAGE_TITLE: ". - Alteración de delay",
  INTERMITTENT_FAILURE_PAGE_TITLE: ". - Dispositivo con falla intermitente",
  LOST_IP_PAGE_TITLE: ". - Dispositivo con posible pérdida de IP",

  PORTUGUESE: "Portugués",
  ENGLISH: "Inglés",
  SPANISH: "Español",
  GERMAN: "Alemán",
  UPDATING_LANGUAGE_WAITING: "Cambiando el idioma, espere un momento",
  UNABLE_TO_ALTER_LANGUAGE: "No fue posible cambiar el idioma del programa.\n",

  // ---------------------------- EXPERT REPORT ----------------------------
  DEVICE_WITH_DIAGNOSTIC_DOTS: "..............................................................................................................",
  DEVICE_WITH_FAULT_DOTS: "...................................................................................................................",
  DEVICES_WITH_DUPLICATE_IP_DOTS: "....................................................................................................",
  DEVICES_WITH_DUPLICATE_NAME_DOTS: "......................................................................................",
  PING_LIMIT_EXCEEDED_DOTS: "..............................................................................................................",
  DELTA_ERROR_ALARM_DOTS: "...................................................................................................................",
  PORT_NOT_IN_FULL_DUPLEX_DOTS: ".................................",
  TRAFFIC_EXCESS_DOTS: ".......................................................................................................",
  INACTIVE_PORT_DOTS: "........................................................................................................................",

  HW_FW_DOTS: "............................................................",
  HW_FW_DOTS_2: "..................................................................",

  MODULE_INCOHERENCE_DOTS: "...........................................",
  MODULE_INCOHERENCE_DOTS_2: "................................................",

  DUPLEX_MISMATCH_DOTS: "..........................................................................................",
  DUPLEX_MISMATCH_DOTS_2: "...........................................................................................",

  DELAY_EXCEEDED_DOTS: "...................................................................................................................",
  DELAY_EXCEEDED_DOTS_2: ".......................................................................................................................",

  DEVICE_WITH_INTERMITTENT_FAILURE_DOTS: "............................................................................................",
  DEVICE_WITH_INTERMITTENT_FAILURE_DOTS_2: "...............................................................................................",

  DISCLAIMER_EXPERT_DOTS: ".................................................................................................................................",
  DISCLAIMER_EXPERT_DOTS_2: "....................................................................................................................................",

  DEVICE_WITH_LOST_IP_DOTS: ".........................................................................................",

  OVERVIEW_DOTS: "............................................................................................................................",
  LIVE_LIST_DOTS: "......................................................................................................................................",
  INVENTORY_DOTS: "...................................................................................................................................",
  TOPOLOGY_DOTS: "...................................................................................................................................",
  IN_TRAFFIC_ERRORS_DOTS: "................................................................................................",
  OUT_TRAFFIC_ERRORS_DOTS: "...................................................................................................",
  MON_LOG_DOTS: "..............................................................................................................................................",
  DISCLAIMER_DOTS: "..................................................................................................................................",
  DISCLAIMER_DOTS_2: ".....................................................................................................................................",

  ADD_ALTER_TAGS: "Agregar/Editar tags",
  CHANGE_TAG_FAILURE: "Ocurrió un error al cambiar la tag.",
  CHANGE_TAG_SUCCESS: "La tag se cambió correctamente.",
  CHOOSE_DEVICE: "Elija un dispositivo",
  CONFIRM_REMOVE_ALL_TAGS: "¿Está seguro de que desea eliminar las tags de todos los dispositivos?",
  EXPORT_TAGS: "Exportar tags",
  IMPORT_TAGS: "Importar tags",
  IMPORT_TAGS_FAILURE: "Ocurrió un error al importar las tags: ",
  IMPORT_TAGS_SUCCESS: "Las tags se importaron correctamente.",
  NEW_TAG: "Nueva tag",
  N_REASON_DP: "\nRazón: ",
  PLEASE_SELECT_DEVICE: "Por favor seleccione un dispositivo.",
  PLEASE_SELECT_TAG_FILE: "Por favor seleccione un archivo de tags.",
  REMOVE: "Eliminar",
  REMOVE_ALL_TAGS: "Eliminar todas las tags",
  REMOVE_TAG_FAILURE: "Ocurrió un error al eliminar las tags.",
  REMOVE_TAG_SUCCESS: "Las tags se eliminaron correctamente.",
  TAGS: "Tag de los dispositivos",
  ACTIVE_COLUMNS: "Columnas activas",

  // PRO topology compatibility
  ACCESS_POINT: "Access Point",
  ADD: "Añadir",
  ADD_DEVICE: "Añadir dispositivo",
  ALERT_AUTO_DETECTED_CONNECTIONS_CANNOT_BE_REMOVED: "No se pueden eliminar las conexiones detectadas automáticamente.",
  ALERT_CHOOSE_DEVICE_TYPE: "Por favor seleccione un tipo de dispositivo",
  ALERT_MANUAL_CONNECTION_CREATION_FAILED: "No se pudo crear la conexión manual.",
  ALERT_ONLY_MANUAL_CONNECTIONS_CAN_BE_REMOVED: "Solo se pueden eliminar las conexiones creadas manualmente.",
  ALERT_ONLY_MANUAL_DEVICES_CAN_BE_EDITED: "Solo se pueden editar los dispositivos creados manualmente.",
  ALERT_ONLY_MANUAL_DEVICES_CAN_BE_REMOVED: "Solo se pueden eliminar los dispositivos creados manualmente.",
  ALERT_SELECT_DIFFERENT_DEVICES_FOR_CONNECTION: "Seleccione dos dispositivos diferentes para crear una conexión.",
  CANCEL: "Cancelar",
  CHOOSE_A_DEVICE: "Seleccione un dispositivo para visualizar su información",
  CURRENT_JITTER: "Jitter actual",
  CURRENT_PING: "Ping actual",
  DEVICE_DEFAULT_DROPDOWN_PLACEHOLDER: "Selecciona un tipo de dispositivo",
  ENDPOINT: "Endpoint",
  FIREWALL: "Firewall",
  GRAPHIC_TOPOLOGY_ADD_REGION: "Agregar región",
  GRAPHIC_TOPOLOGY_CANCEL_REGION_DRAWING: "Cancelar demarcación",
  GRAPHIC_TOPOLOGY_DEFAULT_REGION_NAME: "Planta",
  GRAPHIC_TOPOLOGY_DEVICES: "Dispositivos",
  GRAPHIC_TOPOLOGY_DEVICES_LOWERCASE: "dispositivos",
  GRAPHIC_TOPOLOGY_DEVICE_TAB: "Dispositivo",
  GRAPHIC_TOPOLOGY_DISPLAY_CONFIG_SAVED: "La configuración de visualización se guardó correctamente.",
  GRAPHIC_TOPOLOGY_DISPLAY_CONFIG_SAVE_ERROR: "No fue posible guardar la configuración de visualización.",
  GRAPHIC_TOPOLOGY_DISPLAY_HELP: "Elija qué información aparece debajo de los dispositivos automáticos.",
  GRAPHIC_TOPOLOGY_DISPLAY_TAB: "Visualización",
  GRAPHIC_TOPOLOGY_DRAW_REGION_INSTRUCTION: "Haga clic y arrastre sobre la topología para dibujar la región. Suelte el mouse para ingresar el nombre.",
  GRAPHIC_TOPOLOGY_EDIT_REGION: "Editar región",
  GRAPHIC_TOPOLOGY_FILES_HELP: "Exporte la topología o importe un archivo JSON guardado anteriormente.",
  GRAPHIC_TOPOLOGY_FILES_TAB: "Archivos",
  GRAPHIC_TOPOLOGY_MANUAL_CONNECTION: "Conexión manual",
  GRAPHIC_TOPOLOGY_MANUAL_DEVICES: "Agregado",
  GRAPHIC_TOPOLOGY_NEW_REGION: "Nueva región",
  GRAPHIC_TOPOLOGY_POSITION_HELP: "Edite, guarde o elimine las posiciones actuales de los dispositivos y las regiones.",
  GRAPHIC_TOPOLOGY_POSITION_TAB: "Posición",
  GRAPHIC_TOPOLOGY_REGIONS: "Regiones",
  GRAPHIC_TOPOLOGY_REGIONS_HELP: "Cree áreas de la planta y ajuste cada región directamente en el lienzo.",
  GRAPHIC_TOPOLOGY_REGIONS_LOWERCASE: "regiones",
  GRAPHIC_TOPOLOGY_REGIONS_TAB: "Regiones",
  GRAPHIC_TOPOLOGY_REGION_NAME: "Nombre de la región",
  GRAPHIC_TOPOLOGY_REGION_NAME_PLACEHOLDER: "Ejemplo: Planta-1",
  GRAPHIC_TOPOLOGY_REGION_NAME_REQUIRED: "Ingrese el nombre de la región.",
  GRAPHIC_TOPOLOGY_REMOVE_REGION: "Eliminar región",
  GRAPHIC_TOPOLOGY_SEARCH_EMPTY: "Ingrese una IP, Tag o profiname para buscar.",
  GRAPHIC_TOPOLOGY_SEARCH_NOT_FOUND_1: "No se encontró ningún dispositivo para: ",
  GRAPHIC_TOPOLOGY_SEARCH_NOT_FOUND_2: ".",
  GRAPHIC_TOPOLOGY_SELECTED_REGION_PLACEHOLDER: "Región seleccionada",
  GRAPHIC_TOPOLOGY_SELECT_REGION_TO_EDIT: "Seleccione una región para editar.",
  GRAPHIC_TOPOLOGY_SELECT_REGION_TO_REMOVE: "Seleccione una región para eliminar.",
  GRAPHIC_TOPOLOGY_SHOW_IP: "Mostrar IP",
  GRAPHIC_TOPOLOGY_SHOW_PROFINAME: "Mostrar profiname",
  GRAPHIC_TOPOLOGY_SHOW_TAG: "Mostrar Tag",
  GRAPHIC_TOPOLOGY_SUBTITLE: "Organice los dispositivos, las conexiones y las regiones de la planta",
  GRAPHIC_TOPOLOGY_TITLE: "Topología gráfica",
  HAS_TS_EXPERT_EVENT: "¿Tienes algún evento en TS Expert?",
  HMI: "HMI",
  IP_PLACEHOLDER: "IP (Opcional)",
  LOCALE_ADD_DESCRIPTION: "Haga clic en un espacio en blanco para añadir un nuevo dispositivo",
  LOCALE_ADD_EDGE: "Añadir conexión",
  LOCALE_ADD_NODE: "Añadir dispositivo",
  LOCALE_BACK: "Volver",
  LOCALE_CREATE_EDGE_ERROR: "No fue posible crear conexión a un clúster",
  LOCALE_DEL: "Eliminar seleccionado",
  LOCALE_DELETE_CLUSTER_ERROR: "Los clústeres no se pueden eliminar",
  LOCALE_EDGE_DESCRIPTION: "Haz clic en un dispositivo y arrastra la conexión a otro dispositivo para conectarlos",
  LOCALE_EDIT: "Editar",
  LOCALE_EDIT_CLUSTER_ERROR: "Los clústeres no se pueden editar",
  LOCALE_EDIT_EDGE: "Editar conexión",
  LOCALE_EDIT_EDGE_DESCRIPTION: "Haz clic en los puntos de control y arrástralos a un dispositivo para conectarlos",
  LOCALE_EDIT_NODE: "Editar dispositivo",
  MAX_JITTER: "Jitter máximo",
  MAX_PING: "Ping máximo",
  NO_DEVICE_SELECTED: "Ningún dispositivo seleccionado",
  OPEN_DEVICE_IN_GRAPHIC_TOPOLOGY: "Abrir este dispositivo en la Topología Gráfica",
  PC: "Notebook",
  PS_2: "Nota 2:",
  PS_3: "Nota 3:",
  SELECTED_DEVICE: "Dispositivo seleccionado",
  SERVER: "Servidor",
  SWITCH: "Switch",
  TABLE_TOPOLOGY: "Topología en tabla",
  TAG_PLACEHOLDER: "TAG",
  TAP: "TAP",
  TOPOLOGY_CSV_EXPORT_NAME: "Topología.xlsx",
  TOPOLOGY_CSV_HEADER: "SNMP,Nombre,Modelo,IP,Puerto,Nombre del vecino,Puerto del vecino,IP del vecino\n",
  UNIQUE_DROPPED: "Dropped packets únicos",
  TS_EXPERT_SMART_DIAGNOSIS: "Diagnóstico inteligente PROFINET",
  TS_EXPERT_EVENT_TYPES: "Tipos de eventos",
  TS_EXPERT_OCCURRENCES: "Ocurrencias",
  TRAFFIC_CSV_HEADER: "IP,Nombre,Tiempo encendido,Nombre del puerto,Modo Duplex,Delay,Velocidad de la interfaz,Tráfico de entrada (Kbps),Errores en los paquetes de entrada,Tráfico de salida (Kbps),Errores en los paquetes de salida,Status del puerto\n",
  TRAFFIC_CSV_EXPORT_NAME: "Tráfico.xlsx",
});

export default Strings;